import JQuery, { each } from 'jquery';
// import '../../lib/jquery-1.11.3.min.js';
import Modernizr from 'modernizr';



import '../../lib/jquery.extendable.js';
import '../../lib/jquery.nivasSelect.js';

import '../../lib/jquery.hoverIntent.js';
import '../../lib/jquery.handle.meni.js';
import '../../lib/jquery-ui-accordion-tabs.min.js';
import '../../lib/jquery-ui-custom.js';
import '../../lib/jquery.serializeObject.min.js';
import '../../lib/jquery.responsive-accordion-tabs.js';
import '../../lib/jquery.serializeObject.min.js';
import '../../lib/datepicker.js';
import '../../lib/polyfill.js';

import '../../lib/swiper.jquery.min.js';
import '../../lib/swiper.min.js';

import Swiper, { Navigation, Pagination, Scrollbar } from "swiper";

window.nivas = {					//for Vue
	swiper: {
		Swiper,
		Navigation,
		Pagination,
		Scrollbar
	}
};


import PhotoSwipeUI_Default from '../../lib/photoswipe-ui-default.min.js';
import PhotoSwipe from '../../lib/photoswipe.min.js';

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

//import Swiper, { Navigation, Pagination, Scrollbar } from "swiper";

import MicroModal from 'micromodal';
import Headroom from "headroom.js";

import _, { map } from 'underscore-esm.js';
import moment from 'moment';




// for Vue
window.$ = window.JQuery = JQuery;

// import '../../lib/jquery.fitvids.js';
import '../../lib/object-fit-videos.min.js';
import '../../lib/hammer.min.js';

// import '../../lib/fwajax.js'; // TODO vidjeti zašto ne radi ovo.. 
//moram staviti fwajax direktno u main.js da bi radilo
var fwajax =
{
	type: 'POST',
	dataType: 'json',
	langSegment: '/',
	verbose: true,

	callback_globalAjaxError: function( XMLHttpRequest, textStatus, errorThrown)
	{
		if(fwajax.verbose)
			alert('ajax error: ' + textStatus );
	},
	phpExecute : function(controlObject)
	{


		var obj=new Object;

		obj[ '_fwajax_url' ] = controlObject.url;
		obj[ '_fwajax' ] = '_fwajax';

		for(var i=1; i<arguments.length; i++)
		{
			var objIx='_fwajax_a' + (i-1);
			obj[ objIx ]=arguments[i];
		}

		var newUrl=fwajax.langSegment;
		if( controlObject.url.length >= 1 && controlObject.url.charAt(0)=='/')
			newUrl += controlObject.url.substr(1);
		else
			newUrl += controlObject.url;

		$.ajax(
			{
				url: newUrl,
				data: obj,
				success: fwajax.jsExecute,
				//error: callback_error_test2,
				timeout: 8000
			}
		);
	}, // phpExecute
	jsExecute : function(controlObject, statusText)
	{
		if( typeof( controlObject['_fwajax'] ) == 'undefined' || controlObject['_fwajax']!='_fwajax')
		{
			if(fwajax.verbose)
			{
				alert('jsExecute: Invalid JSON');
			}

			return;
		}

		if( typeof( controlObject['_fwajax_callback'] ) == 'undefined' || controlObject['_fwajax_callback']=='')
		{
			return;
		}

		var callback=controlObject['_fwajax_callback'];

		var evalArgs='';

		for(var i=0; ; i++)
		{
			var ix='_fwajax_a'+i;

			var argType= typeof( controlObject[ix] );

			if( argType == 'undefined')
				break;

			if(evalArgs != '')
				evalArgs += ', ';

			if( argType == 'string')
			{
				//evalArgs += '"' + controlObject[ix].replace(/"/g, '\\"') + '"';
				evalArgs += '"' + controlObject[ix] + '"';
			}
			else
			{
				evalArgs +=  controlObject[ix] ;
			}
		}

		var evalCode=callback+'(' + evalArgs + ')';

		eval( evalCode );

	} // jsExecute
};

$.ajaxSetup(
	{
		type: "POST",
		dataType: "json",
		error: fwajax.callback_globalAjaxError
	}
);



// mora biti window.gtm_Tracking kako bni ga koristio Vue
window.gtm_Tracking = {

	init: function() {

		this.bindTrackAnchor();

	},

	bindTrackAnchor: function() {

		var self = this;

		if($("a.gtm-event").length > 0)
		{
			$("a.gtm-event").each(function(){

				$(this).on("click", function(e){


					var anchorHref = $(this).attr("href");
					var eventCategory = $(this).attr("data-ga-category");
					var eventAction = $(this).attr("data-ga-action");
					var eventLabel = $(this).attr("data-ga-label");
					var eventValue = $(this).attr("data-ga-value");
					var eventNonInteraction = $(this).attr("data-ga-noninteraction");
					var eventOutbound = $(this).attr("data-ga-outbound") == undefined ? false : true;
					var callbackFunction = false;

					////console.log("a.gtm-event", anchorHref, eventOutbound);

					if(eventCategory!==undefined && eventCategory!="" && eventAction!==undefined && eventAction!="")
					{
						if(!eventOutbound)
						{
							e.preventDefault();
							callbackFunction = function(){
								location.href = anchorHref;
							}
						}

						self.trackEvent(eventCategory, eventAction, eventLabel, eventValue, eventNonInteraction, callbackFunction);
					}
				});

			});
		}

		var filetypes = /\.(zip|exe|pdf|doc*|xls*|ppt*|mp3)$/i;
        var baseHref = '';
        if (jQuery('base').attr('href') != undefined) baseHref = jQuery('base').attr('href');

        jQuery('a:not(.gtm-event)').each(function() {

            var href = jQuery(this).attr('href');

            if (href && href.match(/^mailto\:/i))
            {
                jQuery(this).click(function() {
                    var mailLink = href.replace(/^mailto\:/i, '');

                    // ga tracking
                    gtm_Tracking.trackEvent('Email', 'click', mailLink, 1);
                });
            }
            else if (href && href.match(filetypes))
            {
                jQuery(this).click(function(e) {
                    var extension = (/[.]/.exec(href)) ? "-" + /[^.]+$/.exec(href) : '';

                    // ga tracking
                    gtm_Tracking.trackEvent('Download', 'click' + extension, href, 1);
                });
            }

        });

	},

	/**
	 * gtm_Tracking.trackEvent('test', 'console', 'Arena', 1);
	 *
	 * dataLayer.push({"event":"GAEvent","eventCategory":"test","eventAction":"console","eventLabel":"Arena","eventValue":1});
	 */
	trackEvent: function(category, action, label, value, noninteraction, cb) {

		////console.log("trackEvent", category, action, label);

		var eventLabel = label == undefined ? '' : label;
		var eventValue = value == undefined ? '' : value;
		var eventNonInteraction = noninteraction == undefined ? false : noninteraction;
		var callbck = cb == undefined ? false : cb;

		var obj = {
			'event': 'GAEvent',
			'eventCategory': category,
			'eventAction': action,
			'eventLabel': eventLabel,
			'eventValue': eventValue,
			'eventNonInteraction': eventNonInteraction
		};

		if(callbck)
		{
			obj.eventCallback = callbck;
		}

		if(typeof dataLayer !== 'undefined')
		{
			dataLayer.push(obj);
		}
	},

    // old ga3
    // ne koristi se trenutno nigdje (ne poziva se iz vue bookinga)
	trackNetwork: function(category, action, target) {

		////console.log("trackNetwork", category, action, target);
		if(typeof dataLayer !== 'undefined')
		{
			dataLayer.push({
				'event': 'GAEvent',
				'socialNetwork': category,
				'socialAction': action,
				'socialTarget': target
			});
		}

	},

	// Ecommerce Measurement

    // old ga3 
    // ne koristi se trenutno nigdje (ne poziva se iz vue bookinga)
	trackEcommerceProductImpressions: function(products, category, variant, list, currencyCode) {

		if(category === undefined) category = 'Hotel';
		if(variant === undefined) variant = '';
		if(list === undefined) list = 'Hotel room list';
		if(currencyCode === undefined) currencyCode = 'EUR';

		var dataToPush = {
			'ecommerce': {
				'currency': currencyCode,
				'impressions': []
			}
		};

		products.forEach(function(element, index) {

			var itemToPush = {
				'name': element['name'], // 'Triblend Android T-Shirt', // Name or ID is required.
				'id': element['id'], // '12345',
				'price': element['price'], // '15.25',
				'brand': 'Arenahotels', // 'Google',
				'category': category, // 'Apparel',
				'variant': variant, // 'Gray',
				'list': list, // 'Search Results',
				'position': index+1
			};

			dataToPush.ecommerce.impressions,push(itemToPush);

		});

		// console.log("trackEcommerceProductImpressions", dataToPush);

		if(typeof dataLayer !== 'undefined' && dataToPush !== undefined)
		{
			dataLayer.push(dataToPush);
		}

	},

    // novo ga4 2023
    trackEcommerceViewItemList: function(filters, results) {
        console.log("trackEcommerceViewItemList", arguments);

		var products = [];
        var position = 0;
		for(var i=0;i<results.result.length;i++){

            var property = results.result[i];
            position++;

            var productPrice = 0;
            var property_id = '';
            var property_name = '';      
            var accommodation_type = '';      
            if (property['savedData'] !== undefined) {
                property_id = property.savedData.property_id;
                property_name = property.savedData.name;
            }

            if (property["savedData"]["articleData"] !== undefined && property["savedData"]["articleData"]["custom_fields"] !== undefined) {
                // if (property.articleData.custom_fields.google_places_api_id !== undefined) google_places_api_id = property.articleData.custom_fields.google_places_api_id
                if (property.savedData.articleData.custom_fields.accommodation_type !== undefined) accommodation_type = property.savedData.articleData.custom_fields.accommodation_type
                // if (property.articleData.custom_fields.accommodation_city !== undefined) accommodation_city = property.articleData.custom_fields.accommodation_city
            }
            
            if (property["cheapestRate"] !== undefined && property["cheapestRate"]["Price"] !== undefined) {
                productPrice = property.cheapestRate.Price;
            }

            var product = {
                item_id: property_id, // "1234",   //hotel id
                item_name: property_name, // " Park Plaza Arena",  //hotel name
                index: position,       // The index/position of the item in a list.
                item_category: accommodation_type, // "Regular",  // The category of the item (if any)
                price: productPrice,
            }
            products.push(product);
            

        }

        // kreiranje naziva liste (analizirajuci upaljene filtere na booking result list pageu)
        var list_name = "List";
        if (filters["and_group"] !== undefined) {

            for(var i=0;i<filters.and_group.length;i++){
                var filter = filters.and_group[i];

                if (filter["is_active"] !== undefined && filter.is_active == true) {

                    if (filter["criteria"] !== undefined && filter["criteria"]["phobsData"] !== undefined) {

                        if (filter.criteria.phobsData["Property"] !== undefined && filter.criteria.phobsData.Property["City"] !== undefined) {
                            list_name = list_name + " " + filter.criteria.phobsData.Property.City;
                        }

                        if (filter.criteria.phobsData["Property"] !== undefined && filter.criteria.phobsData.Property["attr"] !== undefined && filter.criteria.phobsData.Property.attr["Type"]) {
                            list_name = list_name + " " + filter.criteria.phobsData.Property.attr.Type;
                        }
                    }
                }

            }
        }

        // 2023 GA4
        var dataToPush = {
            event: "view_item_list",
            ecommerce: {
                item_list_name: list_name, // the name of the hotel list depands on the page
                items: products,
            }
        }                

        console.log("view_item_list dataLayer dataToPush", dataToPush);

        if(typeof dataLayer !== 'undefined' && dataToPush !== undefined)
        {
            // dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push(dataToPush);
        }


    },


	// done
	trackEcommerceAddToCart: function(room, category, hotelName, currencyCode, props) {
    // trackEcommerceAddToCart: function(room, category, hotelName, currencyCode, dimensions, props) {

		// if(dimensions === undefined) dimensions = null;
		if(category === undefined) category = 'Hotel';
		if(hotelName === undefined) hotelName = '';
		if(currencyCode === undefined) currencyCode = 'EUR';

		console.log("trackEcommerceAddToCart", arguments);

		if (room['unitData'] !== undefined && room['unitData'].rate !== undefined && room.unitData.rateName !== undefined) {

			//find chosen rate
			if (room.unitData.rateName.includes(" - ")) {


				if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
					var rate = room.unitData.phobsData.rates[room.unitData.rateName];
				} else{

					var segments = room.unitData.rateName.split(" - ");

					if (room.unitData.phobsData.rates[segments[0]] !== undefined) {
						var rate = room.unitData.phobsData.rates[segments[0]];
					}
				}


			} else {

				if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
					var rate = room.unitData.phobsData.rates[room.unitData.rateName];
				}
			}

            // ga4 2023 update - get phobs hotel id (property id) from vudu content article for room/unit 
            var property_id = '';
            var property_name = '';
            var google_places_api_id = '';
            var accommodation_type = '';
            var accommodation_city = '';
            if (room['unitData']['savedData'] !== undefined && room['unitData']['savedData'].property_id !== undefined ) {
                property_id = room.unitData.savedData.property_id;
            }

            if (props !== undefined && props['property'] !== undefined) {
                var property = props['property'];
                if (property.property_id !== undefined) property_id = property.property_id;
                if (property.name !== undefined) property_name = property.name;

                if (property.articleData !== undefined && property.articleData.custom_fields !== undefined) {
                    if (property.articleData.custom_fields.google_places_api_id !== undefined) google_places_api_id = property.articleData.custom_fields.google_places_api_id
                    if (property.articleData.custom_fields.accommodation_type !== undefined) accommodation_type = property.articleData.custom_fields.accommodation_type
                    if (property.articleData.custom_fields.accommodation_city !== undefined) accommodation_city = property.articleData.custom_fields.accommodation_city
                }
            }

			if (rate !== undefined) {

				//find the correct rate variation
				if (rate.variations !== undefined) {
					if (rate.variations[room.unitData.board] !== undefined) {
						rate = rate.variations[room.unitData.board];
					} else {
						return;
					}
				}

				// fallback price
				var productPrice = '0';
				if(room.price !== undefined)
				{
					productPrice = parseFloat(room.price);
				}
				else if (rate.specialStayTotal !== undefined && rate.specialStayTotal.Price !== undefined) {
					productPrice = rate.specialStayTotal.Price;
				}
				else if (rate.StayTotal !== undefined && rate.StayTotal.Price !== undefined)
				{
					productPrice = rate.StayTotal.Price;
				}
				else
				{
					productPrice = rate.Price;
				}

                /*
                // old ga3
				var dataToPush = {
					'event': 'addToCart',
					'ecommerce': {
						'currencyCode': currencyCode,
						'add': { // 'add' actionFieldObject measures.
							'products': [{
								'name': hotelName, // 'Triblend Android T-Shirt', // Name or ID is required.
								'id': room['unitData']['unitID'], // '12345',
								'price': productPrice.toString(), // '15.25',
								'brand': 'Arenahotels', // 'Google',
								'category': category, // 'Apparel',
								'variant': rate.Board, // 'Gray',
								'quantity': 1,
								'dimension1': 'nights',
								'metric1': rate.PriceBreakdown.PriceDay.length !== undefined ? rate.PriceBreakdown.PriceDay.length.toString() : '0',
								'dimension2': 'avaragePrice',
								'metric2': parseFloat(rate.Price).toString()
							}]
						}
					}
				};
                */
                // 2023 GA4
                var dataToPush = {
                    event: "add_to_cart",
                    ecommerce: {
                      currency: currencyCode, // EUR
                     value: productPrice,    
                      items: [
                      {
                        item_id: property_id, // "3f1a7633c89aef28a465b8246d828d75", // phobs proeprty id   //hotel ID
                        item_name: property_name, // hotelName, // "Arena Hotel Holiday",   //hotel name
                        coupon: "",    //coupon name
                        item_brand: "Arena Campsites",    //if the are several brands
                        item_category: accommodation_type, // category, // "VIP",
                        item_category2: rate.Board, // "B/B",   //Room plan
                        item_list_name: accommodation_city, // "Medulin Hotels",
                        item_variant: rate.unitName, // "Double Room", //Room type
                        price: productPrice,
                        quantity: 1,
                        location_id: google_places_api_id, // "EhpSVzdRK1BIRiwgTWVkdWxpbiwgQ3JvYXRpYSImOiQKCg0VH7YaFSPpTggQCxoUChIJJUj9_5grY0cRkNMrhlCtAAQ"  // The physical location associated with the item It's recommended to use the Google Place ID that corresponds to the associated item.
                      }
                    ]
                    }
                  }                



			}

			/*
            // old old old
			dimensioons = {
				dimensions1:'nights',
				metric1:3,
				dimensions2:'adults',
				metric2:1
			}
			*/
			// if(typeof dimensions == "object")
			// {
			// 	dataToPush.ecommerce.add.products[0] = _.extend(dataToPush.ecommerce.add.products[0], dimensions);
			// }
		}

		console.log("addToCart dataLayer dataToPush", dataToPush);

		if(typeof dataLayer !== 'undefined' && dataToPush !== undefined)
		{
            // dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
			dataLayer.push(dataToPush);
		}

	},

	// done
	trackEcommerceRemoveFromCart: function(room, category, variant, currencyCode, props) {

		// if(dimensions === undefined) dimensions = null;
		if(category === undefined) category = 'Hotel';
		if(variant === undefined) variant = '';
		if(currencyCode === undefined) currencyCode = 'EUR';

		console.log("trackEcommerceRemoveFromCart", arguments);

		if (room['unitData'] !== undefined && room['unitData'].rate !== undefined && room.unitData.rateName !== undefined) {

			//find chosen rate
			if (room.unitData.rateName.includes(" - ")) {


				if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
					var rate = room.unitData.phobsData.rates[room.unitData.rateName];
				} else{

					var segments = room.unitData.rateName.split(" - ");

					if (room.unitData.phobsData.rates[segments[0]] !== undefined) {
						var rate = room.unitData.phobsData.rates[segments[0]];
					}
				}


			} else {

				if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
					var rate = room.unitData.phobsData.rates[room.unitData.rateName];
				}
			}



            // ga4 2023 update - get phobs hotel id (property id) from vudu content article for room/unit 
            var property_id = '';
            var property_name = '';
            var google_places_api_id = '';
            var accommodation_type = '';
            var accommodation_city = '';
            if (room['unitData']['savedData'] !== undefined && room['unitData']['savedData'].property_id !== undefined ) {
                property_id = room.unitData.savedData.property_id;
            }

            if (props !== undefined && props['property'] !== undefined) {
                var property = props['property'];
                if (property.property_id !== undefined) property_id = property.property_id;
                if (property.name !== undefined) property_name = property.name;

                if (property.articleData !== undefined && property.articleData.custom_fields !== undefined) {
                    if (property.articleData.custom_fields.google_places_api_id !== undefined) google_places_api_id = property.articleData.custom_fields.google_places_api_id
                    if (property.articleData.custom_fields.accommodation_type !== undefined) accommodation_type = property.articleData.custom_fields.accommodation_type
                    if (property.articleData.custom_fields.accommodation_city !== undefined) accommodation_city = property.articleData.custom_fields.accommodation_city
                }
            }


			if (rate !== undefined) {

				//find the correct rate variation
				if (rate.variations !== undefined) {
					if (rate.variations[room.unitData.board] !== undefined) {
						rate = rate.variations[room.unitData.board];
					} else {
						return;
					}
				}

				// fallback price
				var productPrice = '0';
				if(room.price !== undefined)
				{
					productPrice = parseFloat(room.price);
				}
				else if (rate.specialStayTotal !== undefined && rate.specialStayTotal.Price !== undefined) {
					productPrice = rate.specialStayTotal.Price;
				}
				else if (rate.StayTotal !== undefined && rate.StayTotal.Price !== undefined)
				{
					productPrice = rate.StayTotal.Price;
				}
				else {
					productPrice = rate.Price;
				}

                /*
                // old ga3
				var dataToPush = {
					'event': 'removeFromCart',
					'ecommerce': {
						'currencyCode': currencyCode,
						'remove': { // 'add' actionFieldObject measures.
							'products': [{
								'name': variant, // 'Triblend Android T-Shirt', // Name or ID is required.
								'id': room['unitData']['unitID'], // '12345',
								'price': productPrice.toString(), // '15.25',
								'brand': 'Arenahotels', // 'Google',
								'category': category, // 'Apparel',
								'variant': rate.Board, // 'Gray',
								'quantity': 1,
								'dimension1': 'nights',
								'metric1': rate.PriceBreakdown.PriceDay.length !== undefined ? rate.PriceBreakdown.PriceDay.length.toString() : '0',
								'dimension2': 'avaragePrice',
								'metric2': parseFloat(rate.Price).toString()
							}]
						}
					}
				};
                */
                // 2023 GA4
                var dataToPush = {
                    event: "remove_from_cart",
                    ecommerce: {
                      currency: currencyCode, // EUR
                     value: productPrice,    
                      items: [
                      {
                        item_id: property_id, // "3f1a7633c89aef28a465b8246d828d75", // phobs proeprty id   //hotel ID
                        item_name: property_name, // hotelName, // "Arena Hotel Holiday",   //hotel name
                        coupon: "",    //coupon name
                        item_brand: "Arena Campsites",    //if the are several brands
                        item_category: accommodation_type, // category, // "VIP",
                        item_category2: rate.Board, // "B/B",   //Room plan
                        item_list_name: accommodation_city, // "Medulin Hotels",
                        item_variant: rate.unitName, // "Double Room", //Room type
                        price: productPrice,
                        quantity: 1,
                        location_id: google_places_api_id, // "EhpSVzdRK1BIRiwgTWVkdWxpbiwgQ3JvYXRpYSImOiQKCg0VH7YaFSPpTggQCxoUChIJJUj9_5grY0cRkNMrhlCtAAQ"  // The physical location associated with the item It's recommended to use the Google Place ID that corresponds to the associated item.
                      }
                    ]
                    }
                  }                

			}

			/*
            // old old old 
			dimensioons = {
				dimensions1:'nights',
				metric1:3,
				dimensions2:'adults',
				metric2:1
			}
			*/
			// if(typeof dimensions == "object")
			// {
			// 	dataToPush.ecommerce.remove.products[0] = _.extend(dataToPush.ecommerce.remove.products[0], dimensions);
			// }
		}

        console.log("removeFromCart dataLayer dataToPush", dataToPush);
		if(typeof dataLayer !== 'undefined')
		{
            // dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
			dataLayer.push(dataToPush);
		}

	},

	// done
	trackEcommerceCheckout: function(rooms, category, variant, currencyCode, props, cb) {

		// if(dimensions === undefined) dimensions = null;
		if(category === undefined) category = 'Hotel';
		if(variant === undefined) variant = '';
		if(currencyCode === undefined) currencyCode = 'EUR';
		if (cb === undefined) cb = function () { };
        var revenue = 0;

		// console.log("trackEcommerceCheckout", arguments);

		var products = [];
		for(var i=0;i<rooms.length;i++){

			var room = rooms[i];

			if (room['unitData'] !== undefined && room['unitData'].rate !== undefined && room.unitData.rateName !== undefined) {

				//find chosen rate
				if (room.unitData.rateName.includes(" - ")) {

					if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
						var rate = room.unitData.phobsData.rates[room.unitData.rateName];
					} else{

						var segments = room.unitData.rateName.split(" - ");

						if (room.unitData.phobsData.rates[segments[0]] !== undefined) {
							var rate = room.unitData.phobsData.rates[segments[0]];
						}
					}


				} else {

					if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
						var rate = room.unitData.phobsData.rates[room.unitData.rateName];
					}
				}

                // ga4 2023 update - get phobs hotel id (property id) from vudu content article for room/unit 
                var property_id = '';
                var property_name = '';
                var google_places_api_id = '';
                var accommodation_type = '';
                var accommodation_city = '';
                if (room['unitData']['savedData'] !== undefined && room['unitData']['savedData'].property_id !== undefined ) {
                    property_id = room.unitData.savedData.property_id;
                }

                if (props !== undefined && props['property'] !== undefined) {
                    var property = props['property'];
                    if (property.property_id !== undefined) property_id = property.property_id;
                    if (property.name !== undefined) property_name = property.name;

                    if (property.articleData !== undefined && property.articleData.custom_fields !== undefined) {
                        if (property.articleData.custom_fields.google_places_api_id !== undefined) google_places_api_id = property.articleData.custom_fields.google_places_api_id
                        if (property.articleData.custom_fields.accommodation_type !== undefined) accommodation_type = property.articleData.custom_fields.accommodation_type
                        if (property.articleData.custom_fields.accommodation_city !== undefined) accommodation_city = property.articleData.custom_fields.accommodation_city
                    }
                }

				if(rate !== undefined) {

					//find the correct rate variation
					if(rate.variations !== undefined) {
						if (rate.variations[room.unitData.board] !== undefined) {
							rate = rate.variations[room.unitData.board];
						} else {
							continue;
						}
					}

					// fallback price
					var productPrice = '0';
					if(room.price !== undefined)
					{
						productPrice = parseFloat(room.price);
					}
					else if (rate.specialStayTotal !== undefined && rate.specialStayTotal.Price !== undefined) {
						productPrice = rate.specialStayTotal.Price;
					}
					else if (rate.StayTotal !== undefined && rate.StayTotal.Price !== undefined)
					{
						productPrice = rate.StayTotal.Price;
					}
					else {
						productPrice = rate.Price;
					}

                    revenue += productPrice;
/*
                    // old ga3
					var product = {
						'name': variant, //room['unitData']['phobsData']['name'], // 'Triblend Android T-Shirt', // Name or ID is required.
						'id': room['unitData']['unitID'], // '12345',
						'price': productPrice.toString(), // '15.25',
						'brand': 'Arenahotels', // 'Google',
						'category': category, // 'Apparel',
						'variant': rate.Board, // 'Gray',
						'quantity': 1,
						'dimension1': 'nights',
						'metric1': rate.PriceBreakdown.PriceDay.length !== undefined ? rate.PriceBreakdown.PriceDay.length.toString() : '0',
						'dimension2': 'avaragePrice',
						'metric2': parseFloat(rate.Price).toString(),
						'dimension3': 'adults',
						'metric3': room.adults.toString(),
						'dimension4': 'children',
						'metric4': room.children.length.toString()
					};
*/
                    // 2023 GA4
                    var product = {
                        item_id: property_id, // "3f1a7633c89aef28a465b8246d828d75", // phobs proeprty id   //hotel ID
                        item_name: property_name, // hotelName, // "Arena Hotel Holiday",   //hotel name
                        coupon: "",    //coupon name
                        item_brand: "Arena Campsites",    //if the are several brands
                        item_category: accommodation_type, // category, // "VIP",
                        item_category2: rate.Board, // "B/B",   //Room plan
                        item_list_name: accommodation_city, // "Medulin Hotels",
                        item_variant: rate.unitName, // "Double Room", //Room type
                        price: productPrice,
                        quantity: 1,
                        location_id: google_places_api_id, 
                    };                    

					products.push(product);
				}
			}
		}

        /*
        // old ga3
		var dataToPush = {
			'event': 'checkout',
			'ecommerce': {
				'checkout': {
					'currencyCode': currencyCode,
					'actionField': {'step': 1, 'option': ''},
					'products': products
				}
			}
		};
        */

        var dataToPush = {
			'event': 'begin_checkout',
			'ecommerce': {
                'currency': currencyCode,
                'value': revenue,
                'items': products,
			}
		};


		if(cb)
		{
			dataToPush.eventCallback = cb;
		}

        console.log("trackEcommerceCheckout dataLayer dataToPush", dataToPush);
		if(typeof dataLayer !== 'undefined' && dataToPush !== undefined)
		{
            // dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
			dataLayer.push(dataToPush);
		} else {
			cb();
		}
	},

	// done
	trackEcommercePurchase: function(order, rooms, category, variant, currencyCode, props, cb) {

		// if(dimensions === undefined) dimensions = null;
		if(category === undefined) category = 'Hotel';
		if(variant === undefined) variant = '';
		if(currencyCode === undefined) currencyCode = 'EUR';
		if(cb === undefined) cb = function() {};

		var revenue = 0;

		var reservedRooms = [];

		//use rooms from the order object that contain phobs reservationID
		for(var i = 0; i < order.rooms.length; i++) {
			var reservationID = order.rooms[i][0]['reservationID'];

			for (var j = 0; j < order.rooms[i].length; j++) {
				order.rooms[i][j].reservationID = reservationID;
				reservedRooms.push(order.rooms[i][j]);
			}
		}

		var products = [];
		for (var i = 0; i < reservedRooms.length;i++){

			var room = reservedRooms[i];

			if (room.isFilled && room['unitData'] !== undefined && room['unitData'].rate !== undefined && room.unitData.rateName !== undefined) {
				//find chosen rate
				if (room.unitData.rateName.includes(" - ")) {


					if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
						var rate = room.unitData.phobsData.rates[room.unitData.rateName];
					} else{

						var segments = room.unitData.rateName.split(" - ");

						if (room.unitData.phobsData.rates[segments[0]] !== undefined) {
							var rate = room.unitData.phobsData.rates[segments[0]];
						}
					}


				} else {

					if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
						var rate = room.unitData.phobsData.rates[room.unitData.rateName];
					}
				}

                // ga4 2023 update - get phobs hotel id (property id) from vudu content article for room/unit 
                var property_id = '';
                var property_name = '';
                var google_places_api_id = '';
                var accommodation_type = '';
                var accommodation_city = '';
                if (room['unitData']['savedData'] !== undefined && room['unitData']['savedData'].property_id !== undefined ) {
                    property_id = room.unitData.savedData.property_id;
                }

                if (props !== undefined && props['property'] !== undefined) {
                    var property = props['property'];
                    if (property.property_id !== undefined) property_id = property.property_id;
                    if (property.name !== undefined) property_name = property.name;

                    if (property.articleData !== undefined && property.articleData.custom_fields !== undefined) {
                        if (property.articleData.custom_fields.google_places_api_id !== undefined) google_places_api_id = property.articleData.custom_fields.google_places_api_id
                        if (property.articleData.custom_fields.accommodation_type !== undefined) accommodation_type = property.articleData.custom_fields.accommodation_type
                        if (property.articleData.custom_fields.accommodation_city !== undefined) accommodation_city = property.articleData.custom_fields.accommodation_city
                    }
                }  

				if(rate !== undefined) {

					//find the correct rate variation
					if(rate.variations !== undefined) {
						if (rate.variations[room.unitData.board] !== undefined) {
							rate = rate.variations[room.unitData.board];
						} else {
							return;
						}
					}

					// fallback price
					var productPrice = '0';

					if (order.coupon == "" && room.priceWithoutLoyalty !== undefined) {
						productPrice = parseFloat(room.priceWithoutLoyalty);
					} else if(room.price !== undefined) {
						productPrice = parseFloat(room.price);
					}
					else if (order.coupon !== "" && rate.specialStayTotal !== undefined && rate.specialStayTotal.Price !== undefined) {
						productPrice = rate.specialStayTotal.Price;
					}
					else if(rate.StayTotal.Price !== undefined) {
						productPrice = rate.StayTotal.Price;
					}

					revenue += productPrice;

                    /*
                    // old ga3
					var product = {
						'name': variant, //room['unitData']['phobsData']['name'], // 'Triblend Android T-Shirt', // Name or ID is required.
						'id': room['unitData']['unitID'], // '12345',
						'price': productPrice.toString(), // '15.25',
						'brand': 'Arenahotels', 
						'category': category,
						'variant': rate.Board, 
						'quantity': 1,
						'dimension1': 'nights',
						'metric1': rate.PriceBreakdown.PriceDay.length !== undefined ? rate.PriceBreakdown.PriceDay.length.toString() : '0',
						'dimension2': 'avaragePrice',
						'metric2': parseFloat(rate.Price).toString(),
						'dimension3': 'adults',
						'metric3': room.adults.toString(),
						'dimension4': 'children',
						'metric4': room.children.length.toString(),
						'dimension5': room.reservationID,
						'metric5': 0
					};
                    */
                    // 2023 GA4
                    var product = {
                        item_id: property_id, // "3f1a7633c89aef28a465b8246d828d75", // phobs proeprty id   //hotel ID
                        item_name: property_name, // hotelName, // "Arena Hotel Holiday",   //hotel name
                        coupon: "",    //coupon name
                        item_brand: "Arena Campsites",    //if the are several brands
                        item_category: accommodation_type, // category, // "VIP",
                        item_category2: rate.Board, // "B/B",   //Room plan
                        item_list_name: accommodation_city, // "Medulin Hotels",
                        item_variant: rate.unitName, // "Double Room", //Room type
                        price: productPrice,
                        quantity: 1,
                        location_id: google_places_api_id, 
                    };        
					products.push(product);
				}
			}
		}

        /*
        // old ga3
		var dataToPush = {
			'event': 'purchase',
			'ecommerce': {
				'currencyCode': currencyCode,
				'purchase': {
					'actionField': {
						'id': order.orderId,                         // Transaction ID. Required for purchases and refunds.
						'affiliation': 'Phobs Booking',
						'revenue': revenue,                     // Total transaction value (incl. tax and shipping)
						'tax':'0.00',
						'shipping': '0.00',
						'coupon': order.coupon
					},
					'products': products
				}
			}
		};
        */
		var dataToPush = {
			'event': 'purchase',
			'ecommerce': {
                'transaction_id': order.orderId,                         // Transaction ID. Required for purchases and refunds.
				'currency': currencyCode,
                'value': revenue,
                'coupon': order.coupon,
                'items': products,
		    }
        };

        console.log("trackEcommercePurchase dataLayer dataToPush", dataToPush);

		if(cb)
		{
			dataToPush.eventCallback = cb;
		}

		if(typeof dataLayer !== 'undefined' && dataToPush !== undefined)
		{
			// console.log("trackEcommercePurchase", dataToPush, typeof dataLayer);
            // dataLayer.push({ ecommerce: null });           
			dataLayer.push(dataToPush);
		} else {
			cb();
		}
	}

};



function onYouTubeIframeAPIReady() {
    ArenaturistTrackYoutube.onAPIReady();
}



var ArenaturistTrackYoutube = {

    players: [],
    pauseFlag: false,

    init: function() {

        var tag = document.createElement('script');
        tag.src = "//www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    },

    onAPIReady: function() {

        $('iframe.x_ytb').each(function() {

            var id = $(this).attr("id");
            var player = new YT.Player(id, {
                events: {
                    'onReady': ArenaturistTrackYoutube.onPlayerReady,
                    'onStateChange': ArenaturistTrackYoutube.onPlayerStateChange
                }
            });

            ArenaturistTrackYoutube.players.push(player);
        });

    },

    onPlayerReady: function (event) {

    },

    onPlayerStateChange: function (event) {

        var video_id = event.target.getVideoUrl();

        // track when user clicks to Play
        if (event.data == YT.PlayerState.PLAYING) {
            ArenaturistTrackYoutube.pauseFlag = true;

            // ga tracking
            gtm_Tracking.trackEvent('Video', 'play', video_id, 1);
        }
        // track when user clicks to Pause
        if (event.data == YT.PlayerState.PAUSED && ArenaturistTrackYoutube.pauseFlag) {
            ArenaturistTrackYoutube.pauseFlag = false;

            // ga tracking
            gtm_Tracking.trackEvent('Video', 'pause', video_id, 1);
        }
        // track when video ends
        if (event.data == YT.PlayerState.ENDED) {

        	// ga tracking
            gtm_Tracking.trackEvent('Video', 'finished', video_id, 1);
        }
    }

};



var linker;
function loadBookingiFrame(gaLoaded, frameID, url, opt_hash)
{
    if (gaLoaded) {
        return function(tracker)
        {
            var iFrame = document.getElementById(frameID);
            window.linker = window.linker || new window.gaplugins.Linker(tracker);
            iFrame.src = window.linker.decorate(url, opt_hash);

            iFrame.onload = function()
            {
                $("#divPleaseWait").fadeOut();
                scroll(0,0);
            };
        };
    } else {
        var iFrame = document.getElementById(frameID);
        iFrame.src = url;

        iFrame.onload = function () {
            $("#divPleaseWait").fadeOut();
            scroll(0, 0);
        };
    }
}


// // simulate google analitics
// if(window.ga===undefined)
// {
//     window.ga = function(cb){ cb(); };
// }

// if(window.gaplugins===undefined)
// {
//     var gaplugins = {
//         Linker: function(){
//             return {
//                 decorate: function(url, opt_hash){
//                     return url;
//                 }
//             };
//         }
//     };
// }







// from page_specific.js


var VuduGdprPlugin = {



	options: {
		'necessary': {
			cookieName: 'gdpr_level_1_necessary',
			pristine: true,
			disabled: true,
			checked: true,
			el: 'gdpr_settings_choice_necessary'
		},
		'analytical': {
			cookieName: 'gdpr_level_2_analytical',
			pristine: true,
			disabled: false,
			checked: false,
			el: 'gdpr_settings_choice_analytical'
		},
		'marketing': {
			cookieName: 'gdpr_level_3_marketing',
			pristine: true,
			disabled: false,
			checked: false,
			el: 'gdpr_settings_choice_marketing'
		}
	},

	init: function () {


		if ($('#gdpr_toolbar').length) {
			this.bindEvent();

			var pristine = true;
			for (var i in VuduGdprPlugin.options) {
				var usersSelection = VuduGdprPlugin.options[i];

				var cookieValue = VuduGdprPlugin.getCookie(usersSelection.cookieName);
				if (cookieValue == 1) {
					pristine = false;

					if (usersSelection.disabled === false) {
						VuduGdprPlugin.options[i].checked = true;

						$("#" + usersSelection.el).prop("checked", true);
					}
				}
				else if (cookieValue == 0) {
					pristine = false;

					if (usersSelection.disabled === false) {
						VuduGdprPlugin.options[i].checked = false;

						$("#" + usersSelection.el).prop("checked", false);
					}
				}

			}

			if (pristine == false)
            {
				$("#js-toogle-gdpr").addClass("show");
				VuduGdprPlugin.hideToolbar();
			}
            else
			{
				$("#gdpr_toolbar").removeClass("hide");
			}
		}


	},

	bindEvent: function () {

		$('#gdpr_toolbar .x_submit_necessary').on("click", function (e) {
			e.preventDefault();

			VuduGdprPlugin.consentCookie('necessary', true);
			$('#gdpr_settings_choice_necessary').prop("checked", true);
			VuduGdprPlugin.consentCookie('analytical', false);
			$('#gdpr_settings_choice_analytical').prop("checked", false);
			VuduGdprPlugin.consentCookie('marketing', false);
			$('#gdpr_settings_choice_marketing').prop("checked", false);

			$('#gdpr-overlay').hide();
			$("#gdpr_settings_popup").removeClass("show");
			$('.gdpr-msg').removeClass("show");
			$('#gdpr_toolbar').addClass("hide");
			$('#js-toogle-gdpr').addClass("show");
		});

		$('#gdpr_toolbar a.x_open_setup').on("click", function (e) {
			e.preventDefault();

			$('#gdpr_toolbar .gdpr-prompt__ctrl').toggleClass('active');
			$(this).toggleClass('active');
			$('#gdpr_settings_popup').toggleClass('show');
			$('.gdpr-msg').toggleClass('show');
		});

		$('#js-toogle-gdpr').on("click", function (e) {
			e.preventDefault();

			$('#gdpr_toolbar .gdpr-prompt__ctrl').removeClass('active');
			VuduGdprPlugin.showToolbar();
		});

		$("#gdpr_toolbar .x_submit_selected").on("click", function (e) {
			e.preventDefault();

			$("#gdpr_toolbar input.gdpr_level").each(function (index, item) {
				var name = $(item).val();
				var checked = $(this).prop("checked");
				VuduGdprPlugin.consentCookie(name, checked);
			});

			$('#gdpr_toolbar .gdpr-prompt__ctrl').removeClass('active');
			$('#gdpr_toolbar a.x_open_setup').removeClass('active');

			$('#gdpr-overlay').hide();
			$("#gdpr_settings_popup").removeClass("show");
			$('.gdpr-msg').removeClass("show");
			$('#gdpr_toolbar').addClass("hide");
			$('#js-toogle-gdpr').addClass("show");
		});
	},

	showToolbar: function () {
		$("#gdpr-overlay").show();
		$("#gdpr_toolbar").removeClass('hide');
	},

	hideToolbar: function () {
		$("#gdpr-overlay").hide();
		$("#gdpr_toolbar").addClass('hide');
	},

	consentCookie: function (name, checked) {

		if (VuduGdprPlugin.options[name] !== undefined) {
			var value = checked ? 1 : 0;
			VuduGdprPlugin.setCookie(VuduGdprPlugin.options[name].cookieName, value, 365);
		}
	},

	consentAllCookie: function () {

		for (var i in VuduGdprPlugin.options) {
			var usersSelection = VuduGdprPlugin.options[i];
			VuduGdprPlugin.consentCookie(usersSelection.cookieName, true);
		}
	},

	setLevel: function (lvl) {

		if (typeof (cookieDomainName) != 'undefined' && cookieDomainName) {
			//$.cookie(VuduGdprPlugin.cookieName, lvl, { expires: 365, path: '/', domain: cookieDomainName });
			VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, lvl, 365, cookieDomainName);
		}
		else {
			//$.cookie(VuduGdprPlugin.cookieName, lvl, { expires: 365, path: '/' });
			VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, lvl, 365);
		}
	},

	setMaxLevel: function () {

		if (typeof (cookieDomainName) != 'undefined' && cookieDomainName) {
			//$.cookie(VuduGdprPlugin.cookieName, 4, { expires: 365, path: '/', domain: cookieDomainName });
			VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, 4, 365, cookieDomainName);
		}
		else {
			//$.cookie(VuduGdprPlugin.cookieName, 4, { expires: 365, path: '/' });
			VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, 4, 365);
		}
	},

	setCookie: function (cname, cvalue, exdays, domain) {
		var domain = (typeof (domain) != 'undefined' && domain) ? domain : '.';
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var cookieExpires = "expires=" + d.toUTCString();
		var cookieDomain = "domain=" + domain;
		//document.cookie = cname + "=" + cvalue + ";" + cookieExpires + ";" + cookieDomain + ";path=/";
		document.cookie = cname + "=" + cvalue + ";" + cookieExpires;
	},

	getCookie: function (cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return null;
	}

}

var ArenaturistSocial = {

    defaults: {
        centerBrowser:0, // center window over browser window? {1 (YES) or 0 (NO)}. overrides top and left
        centerScreen:0, // center window over entire screen? {1 (YES) or 0 (NO)}. overrides top and left
        height:500, // sets the height in pixels of the window.
        left:0, // left position when the window appears.
        location:0, // determines whether the address bar is displayed {1 (YES) or 0 (NO)}.
        menubar:0, // determines whether the menu bar is displayed {1 (YES) or 0 (NO)}.
        resizable:0, // whether the window can be resized {1 (YES) or 0 (NO)}. Can also be overloaded using resizable.
        scrollbars:0, // determines whether scrollbars appear on the window {1 (YES) or 0 (NO)}.
        status:0, // whether a status line appears at the bottom of the window {1 (YES) or 0 (NO)}.
        width:500, // sets the width in pixels of the window.
        windowName:null, // name of window set from the name attribute of the element that invokes the click
        windowURL:null, // url used for the popup
        top:0, // top position when the window appears.
        toolbar:0 // determines whether a toolbar (includes the forward and back buttons) is displayed {1 (YES) or 0 (NO)}.
    },


    init: function(){

        var self = this;

        $(document).on("click", ".popupsocial", function(e){
            e.preventDefault();

            self.popup({windowURL: $(this).attr("href")});

            // ga tracking
            gtm_Tracking.trackNetwork($(this).attr("title"), 'Share', $(this).attr("href"));
        });
    },

    popup: function(options) {

        settings = $.extend({}, this.defaults, options || {});

        var windowFeatures =    'height=' + settings.height +
                                ',width=' + settings.width +
                                ',toolbar=' + settings.toolbar +
                                ',scrollbars=' + settings.scrollbars +
                                ',status=' + settings.status +
                                ',resizable=' + settings.resizable +
                                ',location=' + settings.location +
                                ',menuBar=' + settings.menubar;

        settings.windowName = settings.windowName;
        settings.windowURL = settings.windowURL;
        var centeredY,centeredX;

        if(settings.centerBrowser){

            if ($.browser.msie) {//hacked together for IE browsers
                centeredY = (window.screenTop - 120) + ((((document.documentElement.clientHeight + 120)/2) - (settings.height/2)));
                centeredX = window.screenLeft + ((((document.body.offsetWidth + 20)/2) - (settings.width/2)));
            }else{
                centeredY = window.screenY + (((window.outerHeight/2) - (settings.height/2)));
                centeredX = window.screenX + (((window.outerWidth/2) - (settings.width/2)));
            }
            window.open(settings.windowURL, settings.windowName, windowFeatures+',left=' + centeredX +',top=' + centeredY).focus();
        }else if(settings.centerScreen){
            centeredY = (screen.height - settings.height)/2;
            centeredX = (screen.width - settings.width)/2;
            window.open(settings.windowURL, settings.windowName, windowFeatures+',left=' + centeredX +',top=' + centeredY).focus();
        }else{
            window.open(settings.windowURL, settings.windowName, windowFeatures+',left=' + settings.left +',top=' + settings.top).focus();
        }
    }
};

/**
 * Arenaturist galerija
 */
var ArenaturistPhotoSwipe = {

    pswpElement: false,

    init: function() {
        this.pswpElement = document.querySelectorAll('.pswp')[0];

        this.bindGallery();
        this.bindVideo();
        this.bindLiveCam();
    },

    bindGallery: function() {
        var self = this;

        $(document).on("click touchtap", ".x_gallery", function(e){
            e.preventDefault();

            var imageContainer = $(this).attr("data-container");

            var imagez = [];
            $(imageContainer + " .item").each(function(item, index){

                var wh = $(this).attr("data-wh").split("x");

                var img = {};
                img.src = $(this).attr("href");
                img.w = wh[0];
                img.h = wh[1];
                img.title = $(this).attr("alt");
                img.author = $(this).attr("data-author");

                imagez.push(img);

            });


            var idx = $(imageContainer + " .item").index(this);

            var options = {
                index: idx,
                history: false,
                closeOnScroll: false,
                overtitle: $(this).attr("data-overtitle"),
                title: $(this).attr("data-title")
            };

            // ga tracking
            gtm_Tracking.trackEvent('Image Gallery', 'open', options.title, 1);

            self.openOverlay(imagez, options);
//  console.log(imagez);
        });

        $(document).on("click touchtap", ".x_image", function(e){
            e.preventDefault();

            var $imageContainer = $(this).parents(".x_gallery_inline");

            var imagez = [];
            $imageContainer.find(".x_image").each(function(index, item){

                var wh = $(this).attr("data-wh").split("x");

                var img = {};
                img.src = $(this).attr("href");
                img.w = wh[0];
                img.h = wh[1];
                img.title = $(this).attr("alt");
                img.author = $(this).attr("data-author");
                img.index = index;

                imagez.push(img);

            });


            var idx = $imageContainer.find(".g").index(this);

            var options = {
                index: idx,
                history: false,
                closeOnScroll: false,
                overtitle: $imageContainer.attr("data-overtitle"),
                title: $imageContainer.attr("data-title")
            };

            // ga tracking
            gtm_Tracking.trackEvent('Image Gallery', 'open', options.title, 1);

            self.openOverlay(imagez, options);

        });

    },

    bindVideo: function() {

        var self = this;

        // Youtube videos only
        $(document).on("click touchtap", ".x_video", function(e){
            e.preventDefault();

            self.iframes = {};

            var imageContainer = $(this).attr("data-container");
            var pswpElement = document.querySelectorAll('.pswp')[0];

            var imagez = [];
            $(imageContainer + " .item").each(function(item, index){

                var img = {};
                img.html = $(this).html();
                img.title = $(this).attr("data-title");
                img.author = "";

                imagez.push(img);
            });


            var idx = $(imageContainer + " .item").index(this);

            var options = {
                index: idx,
                history: false,
                closeOnScroll: false,
                overtitle: $(this).attr("data-overtitle"),
                title: $(this).attr("data-title")
            };


            // ga tracking
            gtm_Tracking.trackEvent('Video Gallery', 'open', options.title, 1);

            var pswp = self.openOverlay(imagez, options);
            pswp.listen('afterChange', function() {

                $(".pswp .ytb").each(function(index, item){

                    if(index!=pswp.getCurrentIndex())
                    {
                        self.pauseVideo("ytb-" + index);
                    }
                    else
                    {
                        self.playVideo("ytb-" + index);
                    }

                });

            });

        });

	},

    bindLiveCam: function() {

        var self = this;

        // Youtube videos only
        $(document).on("click touchtap", ".x_live", function(e){
            e.preventDefault();

            self.iframes = {};

            var imageContainer = $(this).attr("data-container");
            var pswpElement = document.querySelectorAll('.pswp')[0];

            var imagez = [];
            $(imageContainer + " .item").each(function(item, index){

                var img = {};
                img.html = $(this).html();
                img.title = $(this).attr("data-title");
                img.author = "";

                imagez.push(img);
            });


            var idx = $(imageContainer + " .item").index(this);

            var options = {
                index: idx,
                history: false,
                closeOnScroll: false,
                overtitle: $(this).attr("data-overtitle"),
                title: $(this).attr("data-title")
            };


            // ga tracking
            gtm_Tracking.trackEvent('Live cam', 'open', options.title, 1);

            var pswp = self.openOverlay(imagez, options);
            // pswp.listen('afterChange', function() {

            //     $(".pswp .ytb").each(function(index, item){

            //         if(index!=pswp.getCurrentIndex())
            //         {
            //             self.pauseVideo("ytb-" + index);
            //         }
            //         else
            //         {
            //             self.playVideo("ytb-" + index);
            //         }

            //     });

            // });

        });

    },


    openOverlay: function(imagez, optionz) {

        var self = this;

        var userOptions = (optionz!==undefined && typeof object) ? optionz : {};

        var options = {

            overtitle: false,
            title: false,

            index: 0,
            modal: true,
            history: false,
            loop: true,

            // Buttons/elements
            closeEl: true,
            captionEl: true,
            fullscreenEl: false,
            zoomEl: false,
            shareEl: false,
            counterEl: false,
            arrowEl: true,
            preloaderEl: false,

            // close
            escKey: true,
            pinchToClose: false,
            tapToClose: true,
            closeOnVerticalDrag: false,
            verticalDragRange: 1,
            clickToCloseNonZoomable: false,
            closeOnScroll: false,

            showAnimationDuration: 500,
            hideAnimationDuration: 200
        };
        _.extend(options, userOptions);



        var gallery = new PhotoSwipe( self.pswpElement, PhotoSwipeUI_Default, imagez, options);
        gallery.init();
        gallery.listen('close', function() {
            $(".pswp__container .pswp__item").html("");
        });


        $(".pswp .pswp__head").hide();
        if(options.overtitle || options.title)
        {
            $(".pswp .pswp__head").show();
            $(".pswp .galleryName").html(options.overtitle);
            $(".pswp .galleryDesc").html(options.title);
        }



        return gallery;
    },

    iframes: {},

    pauseVideo: function(sel) {

        if(this.iframes[sel] === undefined)
        {
            var iframe = $(".pswp #" + sel)[0];
            this.iframes[sel] = iframe.contentWindow ? iframe.contentWindow : iframe.contentDocument.defaultView;
        }

        this.iframes[sel].postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    },

    playVideo: function(sel) {

        if(this.iframes[sel] === undefined)
        {
            var iframe = $(".pswp #" + sel)[0];
            this.iframes[sel] = iframe.contentWindow ? iframe.contentWindow : iframe.contentDocument.defaultView;
        }

        this.iframes[sel].postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }

};

/**
 * Newsletter
 */
var ArenaturistNewsletter =
{
    selector : {
        'message': '.newsletter_message',
        'success_message': '.newsletter_message.success',
        'error_message1': '.nm_one.error',
        'error_message1_name': '.nm_one_name.error',
        'error_message1_lastname': '.nm_one_lastname.error',

        'error_message2': '.nm_two.error',
        'error_message3': '.nm_three.error',
        'wrapInputs': '.newsletterWrapInputs',
        'input': '#newsletter_signup input[name=email]',
        'input_name': '#newsletter_signup input[name=first_name]',
        'input_lastname': '#newsletter_signup input[name=last_name]',
        'privola': '#newsletter_signup input[name=privola]',
        'button': '#newsletter_signup [type=submit]'
    },

    init: function()
    {

        console.log("ArenaNewsletter init");

        $(document).on('submit', '#newsletter_signup', function(e) {
            e.preventDefault();
            ArenaturistNewsletter.subscribe($(this));
        });


        $(document).on('submit', '#newsletter_redirect', function(e) {
            e.preventDefault();
            location.href= $(this).attr("data-redirect") + '?email=' + $(this).find('input[name=email]').val();
        });

    },


    subscribe: function($form)
    {
        console.log("ArenaNewsletter subscribe");

        var $input = $(this.selector.input);
        var $input_name = $(this.selector.input_name);
        var $input_lastname = $(this.selector.input_lastname);
        var $privola = $(this.selector.privola);
        var $msg = $(this.selector.message);

        var $errMsg1 = $(this.selector.error_message1);
        var $errMsg1_name = $(this.selector.error_message1_name);
        var $errMsg1_lastname = $(this.selector.error_message1_lastname);
        var $errMsg2 = $(this.selector.error_message2);
        var $errMsg3 = $(this.selector.error_message3);
        var $wrpInps = $(this.selector.wrapInputs);

        $(this.selector.input).removeClass('error');
        $(this.selector.input_name).removeClass('error');
        $(this.selector.input_lastname).removeClass('error');
        $(this.selector.wrapInputs).removeClass('errorArr').removeClass('successArr');
        $msg.removeClass('show');

		var validationOK = true;


		if( $privola.prop('checked') == false )
		{

            // console.log('usli u 1');
			$(this.selector.input).addClass('error');
			$(this.selector.input_name).addClass('error');
			$(this.selector.input_lastname).addClass('error');
            $(this.selector.wrapInputs).addClass('errorArr');
            $(this.selector.error_message3).addClass('show');

			setTimeout( function() {
				$errMsg3.removeClass('show');
				$wrpInps.removeClass('errorArr');
			}, 5000);

			validationOK = false;
        }
        else if(  $input_name.val() == "")
        {
            // console.log('usli u name');
            $(this.selector.input_name).addClass('error');
            $(this.selector.wrapInputs).addClass('errorArr');
            $(this.selector.error_message1_name).addClass('show');
            //setTimeout( ()=> {
            setTimeout( function() {
                $errMsg1_name.removeClass('show');
                $wrpInps.removeClass('errorArr');
            }, 5000);

			validationOK = false;
        }
        else if(  $input_lastname.val() == "")
        {
            // console.log('usli u lastname');
            $(this.selector.input_lastname).addClass('error');
            $(this.selector.wrapInputs).addClass('errorArr');
            $(this.selector.error_message1_lastname).addClass('show');
            //setTimeout( ()=> {
            setTimeout( function() {
                $errMsg1_lastname.removeClass('show');
                $wrpInps.removeClass('errorArr');
            }, 5000);

			validationOK = false;
        }
		else if(  $input.val() == "")
        {
            // console.log('usli u email');
            $(this.selector.input).addClass('error');
            $(this.selector.wrapInputs).addClass('errorArr');
            $(this.selector.error_message1).addClass('show');
            //setTimeout( ()=> {
            setTimeout( function() {
                $errMsg1.removeClass('show');
                $wrpInps.removeClass('errorArr');
            }, 5000);

			validationOK = false;
        }


        if(validationOK)
        {
            var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
            if(re.test($input.val()))
            {
                $(this.selector.button).attr("disabled","disabled");

                fwajax.phpExecute(
                    { url: '/' + langCode + '/xnewsletter/subscribe' },
                    $input.val(),
                    $input_name.val(),
                    $input_lastname.val()
                );

            }
            else
            {
                console.log('Validation u redu');
                $(this.selector.input).addClass('error');
                $(this.selector.wrapInputs).addClass('errorArr');
                $(this.selector.error_message2).addClass('show');
                //setTimeout( ()=> {
                setTimeout( function() {
                    $errMsg2.removeClass('show');
                    $errMsg3.removeClass('show');
                    $wrpInps.removeClass('errorArr');
                }, 5000);
            }
        }

        return false;
    },

    callbackSubscribe: function(str)
    {
        console.log("ArenaNewsletter callbackSubscribe");

        var $input = $(this.selector.input);
        var $privola = $(this.selector.privola);
        var $msg = $(this.selector.message);

        var $sucMsg = $(this.selector.success_message);
        var $wrpInp = $(this.selector.wrapInputs);


        $(this.selector.button).removeAttr("disabled","disabled");
        console.log("str", str);
        if(str)
        {
            var res = jQuery.parseJSON(str);
            console.log("res", res);
            if(res.status>0)
            {
                $(this.selector.success_message).addClass('show');
                $(this.selector.wrapInputs).removeClass('errorArr').addClass('successArr');
                $(this.selector.input).removeClass('error');

/*
                // clickdimensions test
                // start prefill clickdimensions form s nasim podacima
                var $input_email = $(this.selector.input).val();
                var $input_name = $(this.selector.input_name).val();
                var $input_lastname = $(this.selector.input_lastname).val();
                var $privola = $(this.selector.privola).val();
                // console.log($input_email, $input_name, $input_lastname, $privola);

                // Access to XMLHttpRequest at 'xxx' from origin 'yyy' has been blocked by CORS policy: No 'Access-Control-Allow-Origin' header is present on the requested resource.
                var url = 'https://analytics-eu.clickdimensions.com/forms/h/aRwZhxyc4UqSlUdPoB2CUw';
                $.post( url, { firstname: $input_name, lastname: $input_lastname, email: $input_email } )
                .done(function( data ) {
                    console.log( "Data Loaded: " + data );
                });
*/
                $input.val("");
                $privola.prop('checked', false);




                //setTimeout( ()=> {
                setTimeout( function() {
                    $sucMsg.removeClass('show');
                    $wrpInp.removeClass('successArr');

                    // // do the submit
                    // $("#btnSubmit").click();

                }, 5000);

                // ga tracking
                gtm_Tracking.trackEvent('Newsletter', 'submit', 'success', 1);
            }
            else
            {
                $(this.selector.input).addClass('error');
                $(this.selector.wrapInputs).addClass('errorArr');
                $(this.selector.error_message).addClass('show');
            }
        }

    }
};

var isMobile = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    iPad: function() {
        return navigator.userAgent.match(/iPad/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.iPad() || isMobile.Opera() || isMobile.Windows());
    }
};


var ArenaturistRequest = (function () {
    var instance;

    var self = this;
    let $el = false;


    function validateRequestForm(formdata, cb) {

        let callback = (cb !== undefined && typeof cb == "function") ? cb : function(){};

        if(formdata.success_msg === undefined ) formdata.success_msg = [];
        if(formdata.error_msg === undefined ) formdata.error_msg = [];

        $el.find(".xvalidate").removeClass('error');
        $el.find(".msg.msgSuccess").html(msg_txt).removeClass('show');
        $el.find(".msg.msgError").html(msg_txt).removeClass('show');

        // add remove error classes
        for(var field in formdata.form_error)
        {
            var invalid = formdata.form_error[field];
            if(invalid)
            {
                $el.find(".xvalidate#" + field).addClass('error');
                $el.find(".xvalidate." + field).addClass('error');
            }

        }

        var msg_txt = "";
        if(formdata.validate_ok === true)
        {

            for(var i = 0; i < formdata.success_msg.length; i++)
            {
                msg_txt += "<p>" + formdata.success_msg[i] + "</p>";
            }

            $el.find(".msg.msgSuccess").html(msg_txt).addClass('show');
            $el.find(".xvalidate").val("");
            $el.find(".xvalidate").removeAttr("checked");

            // react dates
            $el.find(".DateInput__display-text").html("");
            $el.find(".DateInput__input").val("");
        }
        else
        {
            for(var j = 0; j < formdata.error_msg.length; j++)
            {
                msg_txt += "<p>" + formdata.error_msg[j] + "</p>";
            }
            if (formdata.api_status === true) {
                $el.find(".msg.msgError").html(msg_txt).addClass('show');
            }

        }

        callback();
    }


    function sendRequest(formdata, cb)
    {
        jQuery.ajax({
            url: '/'+langCode+'/xrequest',
            type: 'POST',
            dataType: 'json',
            data: formdata,
            success: function(resData, textStatus, xhr) {
                cb(resData, textStatus, xhr);
            },
            complete: function(xhr, textStatus) {},
            error: function(xhr, textStatus, errorThrown) {}
        });
    }

    function reciveResponse(resData) {

        if(resData.api_status)
        {
            validateRequestForm(resData);

            if(resData.validate_ok === true)
            {
                // ga tracking
				gtm_Tracking.trackEvent('send_request', 'step_3_form_submit', 'success', 1); // new
                gtm_Tracking.trackEvent('Request', 'submit', 'success', 1); // old
                // animacija ako je uspjesan request
                $('html,body').animate({
                    scrollTop: $("#x_top_of_request").offset().top
                },{
                    duration: 500,
                    complete: function() {
                    }
                });
            }
            else
            {
                $('html,body').animate({
                    scrollTop: $("#x_top_of_request").offset().top
                },{
                    duration: 500,
                    complete: function() {
                    }
                });

                // ga tracking
				gtm_Tracking.trackEvent('send_request', 'step_3_form_submit', 'error', 1); // new
                gtm_Tracking.trackEvent('Request', 'submit', 'error', 1);
            }

            if(resData.html !== undefined)
            {

                $("#x_top_of_request").html(resData.html);

                $('html,body').animate({
                    scrollTop: $("#x_top_of_request").offset().top
                },{
                    duration: 500,
                    complete: function() {
                    }
                });
            }

            //ModalSpinner.hide();
        }
        else
        {
            //ModalSpinner.error();
        }
    }


    function construct() {

        $el = $("form#sendRequestForm");

        if($el.length > 0)
        {
            $el.on("submit", function(e){

                e.preventDefault();

                // show hide messages
                $el.find(".msg").removeClass('show');

                var formdata = $(this).serializeObject();

                // mobile fix
                formdata.departure = $el.find("input[name=departure]").val();
                formdata.arrival = $el.find("input[name=arrival]").val();

                validateRequestForm(formdata, function(){
                    sendRequest(formdata, function(resData){
                        reciveResponse(resData);
                    });
                });

            });
        }

    }

    function createInstance() {
        var object = {};
        return object;
    }

    return {
        init: function () {
            if (!instance) {
                construct();
                instance = createInstance();
            }
            return instance;
        }
    };
})();


window.ArenaturistGoogleMaps = {

    position : [43.5019704, 16.4416271],

    map: {},
    marker: {},
    infowindow: {},
    bounds: {},

    init: function() {

        var self = this;

        if($(".x_gmap_direction").length)
        {

            $(".x_gmap_direction").attr('target', '_blank');

        }

        if($(".x_gmap_direction_template").length)
        {

            self.getAutoDirection();

        }

        if($(".x_popup_gmap").length)
        {

            $(".x_popup_gmap").on("click touchtap", function(e){
                e.preventDefault();
                self.popupGoogleMap($(this));
            });

        }

    },

    oncallback: function() {

        var self = this;

        if($("#x_google_multipin_map").length)
        {
            this.showMultiPinMap($("#x_google_multipin_map"));
        }

        if($(".x_google_singlepin_map").length)
        {
            $(".x_google_singlepin_map").each(function(index, el){
                self.showSinglePinMap(el);
            });
        }

        // if($(".x_google_pin_zoom").length && Modernizr.mq('all and (min-width: 900px)'))
        if($(".x_google_pin_zoom").length && window.matchMedia('(min-width: 900px)').matches)
        {
            $(".x_google_pin_zoom").on("click touchtap", function(e){
                e.preventDefault();
                self.zoomToMarker($(this).attr("data-id"));
            });
        }

    },

    zoomPinMap: function($el) {

        var arr = $el.attr("data-latlng").split("|");
        var latLng = new google.maps.LatLng(arr[0], arr[1]);
        this.map.setCenter(latLng);
        this.map.setZoom(15);
    },

    zoomToMarker: function(id) {
        var self = this;

        for(var infwin in this.infowindow)
        {
            if(infwin!==id) this.infowindow[infwin].close();
        }
        this.infowindow[id].open(this.map, this.marker[id]);

        var bounds = new google.maps.LatLngBounds();
        bounds.extend(this.marker[id].position);
        this.map.fitBounds(bounds);
        this.map.setZoom(16);

        setTimeout(function(){
            self.map.setCenter(self.marker[id].getPosition());
        },100);
    },


    showMultiPinMap: function($el) {

        var self = this;

        var pinclass = $el.attr("data-pin-class");

        var fitbounds = $el.attr("data-fitbound") === undefined ? false : true;
        var center = $el.attr("data-latlng") === undefined ? false : $el.attr("data-latlng").split("|");
        var activeid = $el.attr("data-activeid") === undefined ? false : $el.attr("data-activeid");

        var latLng = new google.maps.LatLng(this.position[0], this.position[1]);
        if(center)
        {
            latLng = new google.maps.LatLng(center[0], center[1]);
        }

        var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        var isDraggable = w > 768 ? true : false;
        var DefaultUI= w > 768 ? true : false ;
        var mapOptions = {
            draggable: isDraggable,
            zoomControl: true,
            zoom: 12,
            streetViewControl: false,
            scaleControl: true,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: true,
            center: latLng,
            scrollwheel: false,
            disableDefaultUI: DefaultUI
        };
        var map = self.map = new google.maps.Map(document.getElementById($el.attr("id")), mapOptions);


        self.bounds = new google.maps.LatLngBounds();

        var infowindows = [];
        $("." + pinclass).each(function(index, el){


            var arr = $(el).attr("data-latlng").split("|");
            var id = $(el).attr("id");

            if(arr.length == 2)
            {
                var ico = $(el).attr("data-icon");
                var ttl = $(el).attr("data-title");

                var latLng = new google.maps.LatLng(arr[0], arr[1]);
                self.marker[id] = new google.maps.Marker({
                    position: latLng,
                    map: map,
                    draggable: false,
                    animation: google.maps.Animation.DROP,
                    icon: ico,
                    title: ttl
                });

                self.infowindow[id] = new google.maps.InfoWindow({
                    content: $(el).html()
                });

                self.marker[id].addListener('click', function() {

                    for(var infwin in self.infowindow)
                    {
                        self.infowindow[infwin].close();
                    }

                    self.infowindow[id].open(map, self.marker[id]);
                    map.fitBounds(self.bounds);
                });


                infowindows.push(self.infowindow[id]);

                if(fitbounds) self.bounds.extend(self.marker[id].position);

            }
            ////console.log(id,"==",activeid);
            if(id==activeid)
            {
                self.infowindow[id].open(map, self.marker[id]);
            }

        });


        if(fitbounds) map.fitBounds(self.bounds);
    },

    showSinglePinMap: function(el) {


        var arr = $(el).attr("data-latlng").split("|");
        var latLng = new google.maps.LatLng(arr[0], arr[1]);

        var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        var isDraggable = w > 768 ? true : false;
        var DefaultUI= w > 768 ? true : false ;
        var mapOptions = {
            draggable: isDraggable,
            zoomControl: true,
            zoom: 16,
            streetViewControl: false,
            scaleControl: true,
            mapTypeControl: true,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            center: latLng,
            scrollwheel: false,
            disableDefaultUI: DefaultUI
        };
        var map = new google.maps.Map(el, mapOptions);

        var marker = new google.maps.Marker({
            position: latLng,
            map: map,
            draggable: false,
            animation: google.maps.Animation.DROP
        });

    },

    getInputDirection: function(el) {

        $(el).on("submit", function(e){

            e.preventDefault();

            var formData = $(this).serializeObject();
            var toarr = $(this).attr("data-latlng").split("|");

            if(formData.fromaddr)
            {
                var urlstr = 'https://maps.google.com/maps?saddr=' + formData.fromaddr + '&daddr=' + toarr[0] + ',' + toarr[1] + '&hl=' + langCode ;
                this.popMeUpScotty(urlstr);
                //window.open(urlstr,'_blank');
            }

        });

    },

    getAutoDirection: function($el) {

        var self = this;

        var toarr = window.location.search;
        var tolat = toarr.substring(toarr.indexOf("=") + 1);
            tolat = tolat.substring(0, tolat.indexOf("&"));
        var tolng = toarr.substring(toarr.indexOf("=") + 1);
            tolng = tolng.substring(tolng.indexOf("=") + 1);

        // console.log('tolat', tolat);
        // console.log('tolng', tolng);

        var urlstr = 'https://maps.google.com/maps?saddr=current+location&daddr=' + tolat + ',' + tolng + '&hl=' + langCode;

        window.location = urlstr;

        return false;

    },

    popupGoogleMap: function($el) {

        var toarr = $el.attr("data-latlng").split("|");
        var urlstr = 'http://maps.google.com/maps?q=' + toarr[0] +','+ toarr[1] + '&z=17&hl=' + langCode;

        // this.popMeUpScotty(urlstr);
        window.open(urlstr,'_blank');
    },

    popMeUpScotty: function (url, obj) {

        var usersettings = (obj===undefined || typeof obj !== 'object') ? {} : obj;
        var settings = $.extend({location:0, status:0, scrollbars:1, width:600, height:400, toolbar:0, menubar:0, directories:0, top:50, left:50}, usersettings);
        var arr = [];
        for(var i in settings)
        {
            arr.push(i+"="+settings[i]);
        }

        w = window.open(url, "sutrapopup", arr.join(","));
        /*w.moveTo(0,0);*/
        if($("html").hasClass("no-touch")) w.focus();
    }
};

var ArenaLoader = {

	viewportWidth : false,
	viewportHeight : false,

	firstTime : null,
	loaded : false,

	options : {

		classBackground : '.ldr_background',
		classSrc : '.ldr_src',
		classSrcset : '.ldr_srcset',

		onInit: function(){},
		onFirstTime: function(){},
		onBlock: function(){},
		onFinish: function(){}

	},

	resource : {},


	init : function(options){

		// extend
		ArenaLoader.options = $.extend(ArenaLoader.options, options);

		// viewport
		ArenaLoader.viewportWidth = $( window ).width();
		ArenaLoader.viewportHeight = $( window ).height();

		// events
		$(window).on("nvs:loader:init", ArenaLoader.onInit);
		$(window).on("nvs:loader:new", ArenaLoader.onLoadFirstTime);
		$(window).on("nvs:loader:start", ArenaLoader.onLoadStart);
		$(window).on("nvs:loader:finish", ArenaLoader.onLoadFinish);

		return this;
	},

	run: function() {

		$(window).trigger("nvs:loader:init");

	},

	setResource: function(key, obj) {

		ArenaLoader.resource[key] = obj;

	},

	getResource: function(key) {

		if( ArenaLoader.resource[key] !== undefined )
		{
			return ArenaLoader.resource[key];
		}

		return false;
	},

	/* Events */

	onInit: function() {

		if ( !$.cookie("ldr") )
		{
			// it is first time
			ArenaLoader.firstTime = true;

			ArenaLoader.options.onInit(this);
			$(window).trigger("nvs:loader:new");
		}
		else
		{
			// he was here
			ArenaLoader.firstTime = false;

			ArenaLoader.options.onInit(this);
			$(window).trigger("nvs:loader:start");
		}
	},

	onLoadFirstTime: function() {

		// user code
		ArenaLoader.options.onFirstTime(this);

		// event
		$(window).trigger("nvs:loader:start");
	},

	onLoadStart: function() {

		ArenaLoader.options.onBlock(this);

		// block if first time
		//ArenaLoader.block();

		$(window).trigger("nvs:loader:finish");
	},

	onLoadFinish: function() {

		ArenaLoader.options.onFinish(this);

		// unblock if first time
		ArenaLoader.unblock();

		$.cookie("ldr", "firstLoad", {"expires" : 7});
	},

	block: function() {

		// block images
		if($(ArenaLoader.options.classBackground))
		{
			$(ArenaLoader.options.classBackground).each(function(index, el){

				if($(this).attr('data-ldr-background')==="")
				{
					var backup = $(this).css('background-image');
					$(this).attr("data-ldr-background", backup);
					$(this).css('background-image','');
				}

			});
		}

		if($(ArenaLoader.options.classSrc))
		{
			$(ArenaLoader.options.classSrc).each(function(index, el){

				if($(this).attr('data-ldr-src')==="")
				{
					var backup = $(this).attr('src');
					$(this).attr("data-ldr-src", backup);
					$(this).attr('src', '');
				}

			});
		}

		if($(ArenaLoader.options.classSrcset))
		{
			$(ArenaLoader.options.classSrcset).each(function(index, el){

				if($(this).attr('data-ldr-srcset')==="")
				{
					var backup = $(this).attr('srcset');
					$(this).attr("data-ldr-srcset", backup);
					$(this).attr('srcset', '');
				}

			});
		}

		if($(ArenaLoader.options.classPoster))
		{
			$(ArenaLoader.options.classPoster).each(function(index, el){

				if($(this).attr('data-ldr-poster')==="")
				{
					var backup = $(this).attr('poster');
					$(this).attr("data-ldr-poster", backup);
					$(this).attr('poster', '');
				}

			});
		}

	},

	unblock: function() {


		if($(ArenaLoader.options.classBackground))
		{
			$(ArenaLoader.options.classBackground).each(function(index, el){

				var restore = $(this).attr('data-ldr-background');
				$(this).css("background-image", "url("+restore+")");
			});
		}

		if($(ArenaLoader.options.classSrc))
		{
			$(ArenaLoader.options.classSrc).each(function(index, el){

				var restore = $(this).attr("data-ldr-src");
				$(this).attr('src', restore);
			});
		}

		if($(ArenaLoader.options.classSrcset))
		{
			$(ArenaLoader.options.classSrcset).each(function(index, el){

				var restore = $(this).attr("data-ldr-srcset");
				$(this).attr('srcset', restore);
			});
		}

		if($(ArenaLoader.options.classPoster))
		{
			$(ArenaLoader.options.classPoster).each(function(index, el){

				var restore = $(this).attr("data-ldr-poster");
				$(this).attr('poster', restore);
			});
		}


	}

};

window.isDextop;
window.isHandheld;
var deviceByWidthDetection = (function ($, window, document, undefined) {

    var _utils = {
        _resizeTimeout: null
    };

    var init = function () {

        // Resze lisiner
        var onResize = function () {
            if(_utils._resizeTimeout){
                clearTimeout(_utils._resizeTimeout);
            }
            _utils._resizeTimeout = setTimeout(function(){

                initSelector();

            }, 200);
        };

        $(window).resize(onResize);

        initSelector();
        //console.log('init');

    };

    var initSelector = function(){

        if ( $(window).width() > 899 )
        {
            window.isDextop = true;
            window.isHandheld = false;
            //console.log('desktop');
        }
        else
        {
            window.isHandheld = true;
            window.isDextop = false;
            //console.log('mobile');
        }

    }


    return {
        init: init
    };

})(jQuery, window, document);


if (window.addEventListener) {
    window.addEventListener('DOMContentLoaded', deviceByWidthDetection.init(), false);
}

var footNavigation = {

    wrapper: '.footNav',
    nav: '.nav',
    resizeTimeout: null,
    isMobile: false,
    isDesktop: true,
    map: [],

    init: function() {
        var self = this;

        // Resze lisiner
        var onResize = function () {
            if(self.resizeTimeout){
                clearTimeout(self.resizeTimeout);
            }
            self.resizeTimeout = setTimeout(function(){

                self.initSelector();

            }, 200);
        };

        $(window).resize(onResize);

        this.initSelector();
        //console.log('init');
    },

    initSelector : function(){

        var  self = this;

        if ( $(window).width() > 767 )
        {
            //desktop
            if ( self.isDesktop === false )
            {
                self.cleanup();
                self.isDesktop = true;
                self.isMobile = false;
                //console.log('desktop');
            }
        }
        else
        {
            if ( self.isMobile === false )
            {
                //mobile
                this.setup();

                //wait for setup
                setTimeout(function() {

                    self.bindEvents();

                });

                self.isMobile = true;
                self.isDesktop = false;
                //console.log('mobile');
            }

        }

    },

    RQAFcallBack : function () {
        //console.log('this is RQAF callback', this);
    },

    setup: function() {

        var self = this;

        var ii = 0;
        $(self.nav).find('.t').each(function(i) {

            if ( $(this).next().length !== 0 )
            {
                $(this).append('<span class="more"><span>&raquo;</span></span>');
                $(this).attr('data-id',ii);
                self.map[ii] = 'closed';
                ii = ++ii;
            }

        });

        $(self.nav).find('.wrap').each(function() {

            if ( $(this).find('.in').length == 0 )
            {
                $(this).wrapInner('<div class="in"></div>');
            }

        	var h = $(this).find('.in').height();

            $(this).attr('data-height',h);

        });

        //console.log('setup');

    },

    cleanup: function() {

        var self = this;

        $(self.nav).find('.more').unbind();
        $(self.nav).find('.more').remove();
        $(self.nav).find('.t').removeAttr('data-id');
        $(self.nav).find('.wrap').removeAttr('data-height');
        $(self.nav).find('.wrap').removeAttr('style');

        $(self.nav).find('.in').each(function() {
            $(this).replaceWith($(this).html());
        });

        //console.log('cleanup');

    },

    bindEvents: function() {

        var self = this;

        $('.footNav .more').bind('click', function(e) {

            var ulNav = $(this).parent('.t').next('.wrap');
            //var h = ulNav.attr('data-height');

            // ulNav.animate({'height': h});
            if ( $(this).hasClass('open') )
            {
                self.closePanel(this);
            }
            else
            {
                self.openPanel(this);
            }
            //console.log(self.map);

            //console.log('click');

        });

        //console.log('bind events');

    },

    openPanel: function(elem) {

        var self = this,
            ulNav = $(elem).parent('.t').next('.wrap'),
            h = ulNav.attr('data-height'),
            id = $(elem).parent('.t').attr('data-id');


        $(elem).addClass('open');
        requestAnimationFrame(self.RQAFcallBack, ulNav.animate({'height': h}));
        //console.log(id);
        self.map[id] = 'open';


        self.closeOthers(elem);

        // console.log('open panel');
    },

    closePanel: function(elem) {

        var self = this,
            ulNav = $(elem).parent('.t').next('.wrap'),
            id = $(elem).parent('.t').attr('data-id');

        $(elem).removeClass('open');
        requestAnimationFrame(self.RQAFcallBack, ulNav.animate({'height': '0'}));
        self.map[id] = 'closed';

        // console.log('close panel');

    },

    closeOthers: function(openElem) {

        var self = this;
        var oeid = $(openElem).parent('.t').attr('data-id');

        self.map.forEach(function(item, i) {

            var ii = i.toString();
            //console.log(item);
            //console.log(oeid);
            if ( item === 'open' && ii !== oeid )
            {
            	var elem = $(self.nav).find('.t[data-id="'+i+'"]').children('.more');
                //console.log(elem);
                self.closePanel(elem);
            }


        });



    }

};


// var searchAccoBar = function () {
//     var momentStart = moment();
//     var momentEnd = moment().add(6, 'days');

//     var options = {
//         //"endDate": "10/15/2016", "startDate": "09/15/2016" ispravan format,
//         //"showCustomRangeLabel": false,
//         //"autoUpdateInput": false,
//         "autoApply": true,
//         "startDate": momentStart.format('L'),
//         "endDate": momentEnd.format('L')
//     }

//     $('#searchForm #arrivalDate, #searchForm #departureDate').on('focus', function () {
//         $('#searchForm #datepickerSoul').trigger('click');
//         //console.log('bing');
//     });

//     $('#searchForm #datepickerSoul').daterangepicker(options, function(start, end, label) {
//         $('#searchForm #arrivalDate').val(start.format('YYYY-MM-DD'));
//         //$('#searchForm #departureDate').val(end.format('YYYY-MM-DD'));

//     });
// };


function getReservationLinkBasedOnLang(lang)
{
    var request_url;

    if (lang == 'hr')
    {
        request_url = 'rezervacije';
    }
    else if (lang == 'si')
    {
        request_url = 'rezervacije';
    }
    else if (lang == 'ru')
    {
        request_url = 'bronirovaniie';
    }
    else if (lang == 'it')
    {
        request_url = 'prenotazione';
    }
    else if (lang == 'de')
    {
        request_url = 'buchungen';
    }
    else if (lang == 'en')
    {
        request_url = 'reservations';
    }
    else if (lang == 'nl')
    {
        request_url = 'reservering';
    }
    // fallback
    else
    {
        request_url = 'reservations';
    }

    return request_url;
}

function BookFromTekst(link)
{
    if (link === undefined || link === '')
    {
        return false;
    }

    link = link.replace('secure.phobs.net/booking.php?', serverName + langSegment + getReservationLinkBasedOnLang(langCode) + '?');
    link = link.replace('&hotel', '&acc_id');
    link = link.replace('&date', '&arrival');
    link = link.replace(/&lang=([^&]+)/i, '&lang=' + langCode);

    location.href = link;
}



var bookAccoPage = function () {


    // želimo full lokalne datume. koristiti momentjs
    var range = $('.xRangePicker #arrivalDate').data('range-picker');

    var arrivalDate = $('.xRangePicker #arrivalDate').attr("data-value") !== ""  && $('.xRangePicker #arrivalDate').attr("data-value") !== undefined ? $('.xRangePicker #arrivalDate').attr("data-value") : moment();
    var departureDate = $('.xRangePicker #departureDate').attr("data-value") !== "" && $('.xRangePicker #departureDate').attr("data-value") !== undefined ? $('.xRangePicker #departureDate').attr("data-value") : moment();


    var momentStart = moment(arrivalDate, "YYYY-MM-DD"); // moment();
    var momentEnd =   moment(departureDate, "YYYY-MM-DD"); //moment().add(range, 'days');

    moment.locale('hr');
    //console.log(moment.locale('hr'));

    var options = {
        "autoApply": true,
        "minDate": momentStart.format('L'),
        "startDate": momentStart.format('L'),
        "endDate": momentEnd.format('L'),
        "locale": {
            //format: "L"
            cancelLabel: 'Clear'
        }
    };

    // init

    // $('.xRangePicker #arrivalDate').attr("value", momentStart.format('L'));
    // $('.xRangePicker #departureDate').attr("value", momentEnd.format('L'));
    // $('.xRangePicker input[name=arrival]').attr("value", momentStart.format('YYYY-MM-DD'));
    // $('.xRangePicker input[name=departure]').attr("value", momentEnd.format('YYYY-MM-DD'));


    $('.xRangePicker #arrivalDate').on('focus', function () {
        //$('.xRangePicker #datepickerSoul').trigger('click');
    });

    $('.xRangePicker #departureDate').on('focus', function () {
        //$('.xRangePicker #datepickerSoul').trigger('click');
    });

    $('.xRangePicker #arrivalDate, .xRangePicker #departureDate').on('focus', function () {
        $('.xRangePicker #datepickerSoul').trigger('click');
    });

    $('.xRangePicker #datepickerSoul').daterangepicker(options, function(momentStart, momentEnd, label) {
        // za korisnika prikazujemo locale
        $('.xRangePicker #arrivalDate').attr("value", momentStart.format('L'));
        $('.xRangePicker #departureDate').attr("value", momentEnd.format('L'));

        // serveru šaljemo standarad
        $('.xRangePicker input[name=arrival]').attr("value", momentStart.format('YYYY-MM-DD'));
        $('.xRangePicker input[name=departure]').attr("value", momentEnd.format('YYYY-MM-DD'));
    });


};

var ammenitesTabsAccordion = {

    element: '.ammenitiesBlock',
    resizeTimeout: null,
    isMobile: false,
    isDesktop: false,
    firstLoad: true,
    swiperAmmenities: undefined,
    map: [],
    tabs: [],
    fixedHeight: 380,

    init: function() {
        var self = this;

        if ( $('.ammenitiesBlock').length === 0 ) {
            return;
        }

        // Resze lisiner
        var onResize = function () {
            if(self.resizeTimeout){
                clearTimeout(self.resizeTimeout);
            }
            self.resizeTimeout = setTimeout(function(){

                self.initSelector();
                if ( window.isDextop === true )
                {
                    self.desktopSetActivTab();
                }

            }, 200);
        };

        $(window).resize(onResize);

        // console.log('init');
        this.initSelector();

    },

    initSelector : function(){
        var  self = this;
        //window.isHandheld;
        //window.isDextop;

        if ( window.isDextop === true && self.isDesktop === false )
        //if ( window.isDextop === true )
        {
            self.cleanupMobile();
            self.setupDesktop();
            self.isDesktop = true;
            self.isMobile = false;
            // console.log('desktop');
        }

        if ( window.isHandheld === true && self.isMobile === false )
        //if ( window.isHandheld === true  )
        {
            self.cleanupDekstop();
            self.setupMobile();

            //wait for setup
            setTimeout(function() {
                self.bindEvents();
            });

            self.isMobile = true;
            self.isDesktop = false;
            // console.log('mobile');
        }

        self.firstLoad = false;
    },

    RQAFcallBack : function () {
        //console.log('this is RQAF callback', this);
    },

    setupDesktop: function() {

        var self = this;

        $(self.element).find('.t').each(function(i) {
            self.tabs[i] = $(this).html();
        });

        self.swiperAmmenities = new Swiper('.ammenitiesBlock .swiper-container', {
            speed: 500,
            pagination: '.ammenitiesBlock .swiper-pagination',
            paginationClickable: true,
            onInit: function (swiper) {
                self.desktopSetActivTab();
            },
            paginationBulletRender: function (index, className) {
                return '<li class="' + className + '">' + self.tabs[index] + '</li>';
            },
            //direction: 'vertical',
            onSlideChangeStart: function (swiper) {
                self.desktopSetActivTab();
            }
        });
    },

    setupMobile: function() {

        var self = this;

        var ii = 0;
        $(self.element).find('.t').each(function(i) {

            if ( $(this).next().length !== 0 )
            {
                $(this).attr('data-id',ii);
                self.map[ii] = 'closed';
                ii = ++ii;
            }

        });

        $(self.element).find('.swiper-slide').each(function() {

            var h = $(this).find('.text').height();

            //$(this).attr('data-height',h);
            $(this).attr('data-height',self.fixedHeight);

        });

        //console.log('setup');

    },

    cleanupDekstop: function() {

        var self = this;

        if ( self.swiperAmmenities instanceof Swiper )
        {
            self.swiperAmmenities.destroy(true, true);
            //console.log('destroyed');
        }
        //console.log(self.swiperAmmenities);

    },

    cleanupMobile: function() {

        var self = this;

        $(self.element).find('.t').unbind();
        $(self.element).find('.t').removeAttr('data-id');
        $(self.element).find('.swiper-slide').removeAttr('data-height');
        $(self.element).find('.swiper-slide').removeAttr('style');

        //console.log('cleanup');

    },

    bindEvents: function() {

        var self = this;

        $(self.element).find('.t').bind('click', function(e) {

            if ( $(this).hasClass('open') )
            {
                self.closePanel(this);
            }
            else
            {
                self.openPanel(this);
            }
            //console.log('click');

        });

         //console.log('bind events');

    },

    openPanel: function(elem) {

        var self = this,
            panel = $(elem).next('.swiper-slide'),
            h = panel.attr('data-height'),
            id = $(elem).attr('data-id');


        $(elem).addClass('open');
        requestAnimationFrame(self.RQAFcallBack, panel.animate({'height': h}));
        //console.log(id);
        self.map[id] = 'open';

        self.closeOthers(elem);

        // console.log('open panel');
    },

    closePanel: function(elem) {

        var self = this,
            panel = $(elem).next('.swiper-slide'),
            id = $(elem).attr('data-id');

        $(elem).removeClass('open');
        requestAnimationFrame(self.RQAFcallBack, panel.animate({'height': '0'}));
        self.map[id] = 'closed';

        // console.log('close panel');

    },

    closeOthers: function(openElem) {

        var self = this;
        var oeid = $(openElem).attr('data-id');

        self.map.forEach(function(item, i) {

            var ii = i.toString();
            //console.log(item);
            //console.log(oeid);
            if ( item === 'open' && ii !== oeid )
            {
                var elem = $(self.element).find('.t[data-id="'+i+'"]');
                //console.log(elem);
                self.closePanel(elem);
            }

        });

       //console.log('close othets');

    },

    desktopSetActivTab: function () {

        var activeTab = $('.ammenitiesBlock .swiper-pagination .swiper-pagination-bullet-active');
        var poz = activeTab.position().left;
        var wid = activeTab.width();
        var activeIndicator = $('.ammenitiesBlock .wrap-swiper-pagination .active');
        activeIndicator.css({
            'width': wid+'px',
            'left': poz+'px'
        });

    }

};

var ammenitesSlider = {

    element: '.ammenitiesBlock',
    resizeTimeout: null,
    isMobile: false,
    isDesktop: false,
    firstLoad: true,
    swiperAmmenitiesPager: undefined,
    swiperAmmenities: undefined,
    map: [],
    tabs: [],
    fixedHeight: 380,

    init: function() {
        var self = this;

        if ( $('.ammenitiesBlock').length === 0 ) {
            return;
        }

        // Resze lisiner
        var onResize = function () {
            if(self.resizeTimeout){
                clearTimeout(self.resizeTimeout);
            }
            self.resizeTimeout = setTimeout(function(){

                self.initSelector();
                if ( window.isDextop === true )
                {
                    self.desktopSetActivTab();
                }

            }, 200);
        };

        $(window).resize(onResize);

        // console.log('init');
        this.initSelector();

    },

    initSelector : function(){
        var  self = this;
        //window.isHandheld;
        //window.isDextop;

        if ( window.isDextop === true && self.isDesktop === false )
        {
            self.cleanupMobile();
            self.setupDesktop();

            self.isDesktop = true;
            self.isMobile = false;
            // console.log('desktop');
        }

        if ( window.isHandheld === true && self.isMobile === false )
        {
            self.cleanupDekstop();
            self.setupMobile();

            self.isMobile = true;
            self.isDesktop = false;
            // console.log('mobile');
        }
    },

    RQAFcallBack : function () {
        //console.log('this is RQAF callback', this);
    },

    setupDesktop: function() {

        var self = this;

        $(self.element).find('.wrap-swiper-thumbs .swiper-slide').each(function(i) {
            self.tabs[i] = $(this).html();
        });

        //console.log('setup dekstop');
        self.swiperAmmenities = new Swiper('.ammenitiesBlock .wrap-swiper-content', {
            spaceBetween: 10,
            speed: 500,
            pagination: '.ammenitiesBlock .swiper-pagination',
            paginationClickable: true,
            onInit: function (swiper) {
               self.desktopSetActivTab();
            },
            paginationBulletRender: function (index, className) {
               return '<li class="' + className + '">' + self.tabs[index] + '</li>';
            },
            onSlideChangeStart: function (swiper) {
               self.desktopSetActivTab();
            }
        });

    },

    setupMobile: function() {

        var self = this;

        //console.log('setup mobile');
        self.swiperAmmenitiesPager = new Swiper('.ammenitiesBlock .wrap-swiper-thumbs', {
            spaceBetween: 10,
            centeredSlides: true,
            slidesPerView: 'auto',
            touchRatio: 0.2,
            slideToClickedSlide: true
        });
        self.swiperAmmenities = new Swiper('.ammenitiesBlock .wrap-swiper-content', {
            spaceBetween: 10
        });
        self.swiperAmmenitiesPager.params.control = self.swiperAmmenities;
        self.swiperAmmenities.params.control = self.swiperAmmenitiesPager;

    },

    cleanupDekstop: function() {

        var self = this;

        if ( self.swiperAmmenities instanceof Swiper )
        {
            self.swiperAmmenities.destroy(true, true);
            console.log('destroj swipers cleanupDekstop');
        }

    },

    cleanupMobile: function() {

        var self = this;

        if ( self.swiperAmmenities instanceof Swiper )
        {
            self.swiperAmmenitiesPager.destroy(true, true);
            self.swiperAmmenities.destroy(true, true);
            //console.log('destroj swipers cleanupMobile');
        }

    },

    desktopSetActivTab: function () {

        var activeTab = $('.ammenitiesBlock .swiper-pagination .swiper-pagination-bullet-active');
        var poz = activeTab.position().left;
        var wid = activeTab.width();
        var activeIndicator = $('.ammenitiesBlock .wrap-swiper-pagination .active');
        activeIndicator.css({
            'width': wid+'px',
            'left': poz+'px'
        });

    }


};


// var searchAccoBar = function () {
//     var options = {
//         "startDate": "07/15/2016",
//         "endDate": "07/21/2016"
//     }
//     $('#searchForm #arrivalDate, #searchForm #departureDate').on('focus', function () {
//         $('#datepickerSoul').trigger('click');
//         //console.log('bing');
//     });

//     $('#datepickerSoul').daterangepicker(options, function(start, end, label) {
//         $('#searchForm #arrivalDate').val(start.format('DD-MM-YYYY'));
//         $('#searchForm #departureDate').val(end.format('DD-MM-YYYY'));

//         /*console.log(
//             'New date range selected: ' +
//             start.format('YYYY-MM-DD') +
//             ' to ' +
//             end.format('YYYY-MM-DD') +
//             ' (predefined range: ' +
//             label + ')');
//             */
//     });
// };

$.fn.dropDownOnHover = function (selector) {

    return $(this).each(function() {

        $(this).find('a').not('.sub a').on('click', function(e){ e.preventDefault(); });

        var _goDown = function () {
            $(this).find('.sub').slideDown();
            $(this).addClass('active');
        };

        var _goUp = function () {
            $(this).find('.sub').slideUp();
            $(this).removeClass('active');
        };

        var config = {
            sensitivity: 1, // number = sensitivity threshold (must be 1 or higher)
            interval: 10, // number = milliseconds for onMouseOver polling interval 200
            over: _goDown, // function = onMouseOver callback (REQUIRED)
            timeout: 300, // number = milliseconds delay before onMouseOut 300
            out: _goUp // function = onMouseOut callback (REQUIRED)
        };

        $(this).hoverIntent( config );

    });

};

$.fn.dropDownOnClick = function() {

    return $(this).each(function() {

        var self = this;

        var items = $(this).find('li').not('.sub li');

        var _goDown = function (elem) {

            $(elem).next('.sub').slideDown(300);
            $(elem).parent('li').addClass('active');

        };

        var _goUp = function (elem) {

            $(elem).next('.sub').slideUp(300);
            $(elem).parent('li').removeClass('active');

        };

        var _closeOthers = function (index) {

           for ( var i = 0; i < items.length; i++ )
            {
                if ( i !== index )
                {
                    if ( $(items[i]).hasClass('active') )
                    {
                        var elem = $(items[i]).find('a').not('.sub a');
                        _goUp(elem);
                    }
               }
            }

        };

        $(this).find('a').not('.sub a').on('click', function(e){

            e.preventDefault();
            if ( $(this).parent('li').hasClass('active') )
            {
                _goUp(this);
            }
            else
            {
                var index = $(this).parent('li').index();
                _goDown(this);
                _closeOthers(index);
            }

        });

        $(document).click(function(event) {

            if( !$(event.target).closest('.filter').length ) {

                if( $('.filter .sub').is(":visible") ) {

                    //console.log('bing');
                    _closeOthers(-1);

                }

            }

        })

    });

};

var equalheight = function(container){




    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el,
        topPosition = 0;


    return $(container).each(function() {

        $el = $(this);
        $($el).height('auto')
        topPostion = $el.position().top;

        if (currentRowStart != topPostion) {
            for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
            rowDivs.length = 0; // empty the array
            currentRowStart = topPostion;
            currentTallest = $el.height();
            rowDivs.push($el);
        } else {
            rowDivs.push($el);
            currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
        }
        for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
            // console.log($el === $('#tour_block_all .tour_box .box'));
        }
    });
};

var equalheightWraper = function () {

    var boxSy4 = '.accoList .boxStyle4, .destList .boxStyle4, .downloadAppPage .wrapText';
    var pinsWrap = '.accomodationListMap .hrPins';

    if ( $(boxSy4).length ) {
    	if (window.matchMedia('(min-width: 768px)').matches) {
            equalheight(boxSy4);
        } else if ( $(boxSy4).attr('style') ) {
            $(boxSy4).removeAttr('style');
        }
    }

    if ( $(pinsWrap).length ) {
    	if (window.matchMedia('(min-width: 768px)').matches) {
            equalheight(pinsWrap);
        } else if ( $(pinsWrap).attr('style') ) {
            $(pinsWrap).removeAttr('style');
        }
    }

};

var homePageHead = {

    win: $(window),
    elem: $('#pageHead'),
    element: '#pageHead',
    img: '#pageHead img.gf',
    resizeTimeout: null,
    map: [],
    lastScrl: null,
    aboveFoldDim: null,
    ww: null,
    wh: null,
    iw: null,
    ih: null,
    offset: null,
    swiperHome: null,

    setup: function() {

        this.lastScrl = this.win.scrollTop();
        this.ww = this.win.width();
        this.wh = this.win.height();
        this.offset = this.ww > 900 ? 200 : 60;
        this.aboveFoldDimUnlimited = this.wh - this.offset;
        this.aboveFoldDim = this.aboveFoldDimUnlimited > 704 ? 704 : this.aboveFoldDimUnlimited;
        this.iw = 1680;
        this.ih = this.ww > 767 ? 704 : 570;

        // console.log(this.offset)
        // console.log(this.aboveFoldDim);
    },

    init: function() {

        var self = this;

        if ( $('.homePage').length === 0 )
        {
            return;
        }

        // Resze lisiner
        var onResize = function () {
            if(self.resizeTimeout){
                clearTimeout(self.resizeTimeout);
            }
            self.resizeTimeout = setTimeout(function(){

                //if ( window.isDextop === true )
                //{
                    //do stuff
                    self.setup();
                    self.setDimentions();
                    self.handleGfxSize();

                //}

            }, 200);
        };

        $(window).resize(onResize);

        self.setup();
        self.setDimentions();
        self.scrollAction();
        self.handleGfxSize();

        self.swiperAction();
        //self.swiperActionAlt();

    },

    swiperAction: function() {

        self.swiperHome = new Swiper('.homeHead .swiper-container', {
           //pagination: '.homeHead .swiper-pagination',
            //nextButton: '.homeHead .swiper-next',
            //prevButton: '.homeHead .swiper-prev',

			modules: [Navigation, Pagination, Scrollbar],

			navigation: {
                nextEl: ".homeHead .swiper-next",
                prevEl: ".homeHead .swiper-prev",
            },
            paginationClickable: true,
            speed: 1000,
            autoplay: 10000,
            autoplayDisableOnInteraction: true,
            loop:  true

        });

    },

    swiperActionAlt: function() {

        var interleaveOffset = -.5;

        var interleaveEffect = {

            onProgress: function(swiper, progress){
                for (var i = 0; i < swiper.slides.length; i++){
                    var slide = swiper.slides[i];
                    var translate, innerTranslate;
                    progress = slide.progress;

                    if (progress > 0)
                    {
                        translate = progress * swiper.width;
                        innerTranslate = translate * interleaveOffset;
                    }
                    else
                    {
                        innerTranslate = Math.abs( progress * swiper.width ) * interleaveOffset;
                        translate = 0;
                    }

                    $(slide).css({
                        //transform: 'translate3d(' + translate + 'px,0,0)'
                    });

                    $(slide).find('.slide-inner').css({
                        transform: 'perspective(1200px) translateZ(' + innerTranslate + 'px)'

                    });
                }
            },

            onTouchStart: function(swiper){
                for (var i = 0; i < swiper.slides.length; i++){
                    $(swiper.slides[i]).css({ transition: '' });
                }
            },

            onSetTransition: function(swiper, speed) {
                for (var i = 0; i < swiper.slides.length; i++){
                    $(swiper.slides[i])
                        .find('.slide-inner')
                        .andSelf()
                        .css({ transition: speed + 'ms' });
                }
            }
        };

        var swiperOptions = {
            // loop: true,
            // speed: 1000,
            // grabCursor: true,
            watchSlidesProgress: true,
            // mousewheelControl: true

            nextButton: '.homeHead .swiper-next',
            prevButton: '.homeHead .swiper-prev',
            paginationClickable: true,
            loop: true,
            speed: 1000,


            
            //autoplay: 2000,
            autoplayDisableOnInteraction: true
        };

        swiperOptions = $.extend(swiperOptions, interleaveEffect);

        var swiper = new Swiper('.homeHead .swiper-container', swiperOptions);

    },

    setDimentions: function() {

        var self = this;

		/*

		if ( self.ww > 767 ) {
			$(self.element).height(self.aboveFoldDim);
		}
		else {
			$(self.element).height('auto');
		}
		*/

    },

    handleGfxSize: function() {

        var self = this;

        $(self.img).each(function(){

            var imgAspectRatio = self.iw / self.ih;
            var winAspectRatio = self.ww / self.wh;

            var calc = ( self.wh - self.offset ) * imgAspectRatio;
            //calc = Math.round(calc * 100) / 100; //round 2 places
            calc = Math.round(calc);
            calc = calc > 1680 ? 1680 : calc;
            //console.log(calc);

            if ( $(window).width() > 767 )
            {
                if ( winAspectRatio < imgAspectRatio )
                {
                    $(this).css('width', calc+'px');
                }
                else
                {
                    $(this).css('width', '100%');
                }
            }
            else
            {
                $(this).css({
                    'height': '100%',
                    'width': 'auto'
                });
            }
        });

    },

    scrollAction: function() {

        var self = this;

        $(window).scroll(function(){

            var currentScrl = $(window).scrollTop();

            //in the zone
            if ( self.aboveFoldDim > currentScrl && self.lastScrl !== currentScrl )
            {
                //console.log('in the zone');
                //do action
            }

            if ( currentScrl > 200 )
            {
                $('.scrollCta').addClass('hidden');
                //do action
            }
            else
            {
                $('.scrollCta').removeClass('hidden');
            }

            self.lastScrl = currentScrl;

        });



    }


};

$.fn.boxStyle6Action = function (selector) {

    return $(this).each(function() {

        var elem = $(this),
            text = elem.find('.mainText'),
            attrText = elem.find('.attrText'),
            addiText = elem.find('.addiText'),
            cta = elem.find('.action a'),
            th = 0,
            ath = 0,
            adh = 0,
            resizeTimeout = null;

        var setup = function () {

            text.find('p, ul').not('.overtitle').slice( 1 ).wrapAll('<div class="wrap"><div class="in"></div></div>');
            attrText.find('.wrap').wrapInner('<div class="in"></div>');
            addiText.find('.wrap').wrapInner('<div class="in"></div>');

            th = text.find('.in').height();
            ath = attrText.find('.in').height();
            adh = addiText.find('.in').height();

            text.find('.wrap').attr('data-height', th);
            attrText.find('.wrap').attr('data-height', ath);
            addiText.find('.wrap').attr('data-height', adh);

            text.find('.wrap').height(0);
            attrText.find('.wrap').height(0);
            addiText.find('.wrap').height(0);

            cta.css('display','block');
            elem.prepend('<div class="bg"></div>');


        };

        var open = function () {

            text.find('.wrap').height(th);
            attrText.find('.wrap').height(ath);
            addiText.find('.wrap').height(adh);

            cta.addClass('open');
            elem.addClass('opanel');

            //setTimeout(function() {
            //    $('html, body').animate({scrollTop: elem.offset().top });
            //}, 100);

        };

        var close = function () {

            text.find('.wrap').height(0);
            attrText.find('.wrap').height(0);
            addiText.find('.wrap').height(0);

            cta.removeClass('open');
            elem.removeClass('opanel');

        };

        var setNavPoz = function () {

            $('#siteHead').addClass("menu_slide_down");
            $('#siteHead').removeClass("menu_slide_up");
        };

        var closeOthers = function(el) {

            $('.wrapBox6').find('.action a.open').not(el).trigger('click');

        };

        // Resze lisiner
        var onResize = function () {
            if(resizeTimeout){
                clearTimeout(resizeTimeout);
            }
            resizeTimeout = setTimeout(function(){

                th = text.find('.in').height();
                ath = attrText.find('.in').height();
                adh = addiText.find('.in').height();

                text.find('.wrap').attr('data-height', th);
                attrText.find('.wrap').attr('data-height', ath);
                addiText.find('.wrap').attr('data-height', adh);

            }, 200);
        }

        $(window).resize(onResize);

        setup();

        if ( ( th + ath + adh ) === 0 )
        {
            //ako nema kaj za pokazati makni cta
            elem.find('.action').empty();
        }
        else
        {
            cta.on('click', function (e) {

                e.preventDefault();

                if ( $(this).hasClass('open') )
                {
                    close();
                }
                else
                {
                    open();
                    closeOthers(this);
                }

            }).on('webkitTransitionEnd transitionend msTransitionEnd oTransitionEnd', function() {
                //radi dobro samo sa css tranzicijama
                //ne radi dobro sa jQuery animate
                if ( $(this).hasClass('open') ) {
                    //console.log('completed on transition end');

                    /*
                    var scrollPoz = elem.offset().top - $('#siteHead').height();
                    $( 'html, body' ).animate({
                        scrollTop: scrollPoz
                    }, {
                        duration: 250,
                        easing: 'easeInCubic',
                        complete: function() {
                           setNavPoz();
                        }
                    });
                    */

                }
            });
        }



    });

};

$.fn.expandableList = function (selector) {

    return $(this).each(function() {

        var elem = $(this),
            text = elem.find('.text'),
            cta = elem.find('.more'),
            resizeTimeout = null;

        var setup = function () {

            elem.find('ul li').slice( 4 ).addClass('hide');
            cta.show();

        };

        var open = function () {

            elem.find('ul li.hide').removeClass('hide');
            cta.addClass('open');

        };

        var close = function () {

            elem.find('ul li').slice( 4 ).addClass('hide');
            cta.removeClass('open');

        };

        setup();

        cta.on('click', function (e) {

            e.preventDefault();

            if ( $(this).hasClass('open') )
            {
                close();
            }
            else
            {
                open();
            }

        })

    });

};

var downloadDocs = function() {
    $('div[class$="Content"] a[href$=".pdf"]').addClass('pdf');
    $('div[class$="Content"] a[href$=".doc"]').addClass('word');
    $('div[class$="Content"] a[href$=".xdoc"]').addClass('word');
    $('div[class$="Content"] a[href$=".xlsx"]').addClass('exel');
    $('div[class$="Content"] a[href$=".jpg"]').addClass('jpg');
    $('div[class$="Content"] a[href$=".rar"]').addClass('zip');
    $('div[class$="Content"] a[href$=".zip"]').addClass('zip');
};

// var cookie_master = function(){

//     var cp = document.getElementById('cookie');
//     if (typeof(cp) != 'undefined' && cp != null && document.cookie.indexOf('notice') === -1)
//     {

//         var expiry = new Date();
//             expiry.setTime(expiry.getTime()+(365*86400000)); // 365 days
//         var ctaApprove = cp.getElementsByClassName('close_cookie')[0];

//         cp.classList.add('showme');

//         /*$(window).scroll( function() {
//             if ( $(window).scrollTop() > 100 ) {
//                 cp.classList.remove('showme');
//                 document.cookie = "notice=yes; expires=" + expiry.toGMTString();
//             }
//         });*/


//         ctaApprove.onclick = function(e){
//                 //console.log('cookie button');
//             e.preventDefault();
//             cp.classList.remove('showme');
//             document.cookie = "notice=yes; expires=" + expiry.toGMTString() + "; path=/";
//         };

//     }
// };

var hoverica = function () {

    if ( window.isDextop === true )
    {
        $('.sendRequestForm input, .sendRequestForm select, .sendRequestForm textarea').hover(
            function () {
                $(this).prev('label').css({
                    'overflow': 'visible',
                    'z-index': '10',
                    'background-color': '#fff'
                });
            },
            function () {
                $(this).prev('label').removeAttr('style');
            }
        );
    }

};

var extLinks = function () {

    //$('a[href^="http"]').not('#gallery_overlay a, #lang a').each(function(){
    $('a[href^="http"]').each(function(){
        if (this.hostname !== location.hostname && !this.hostname.endsWith('arenacampsites.com') && !this.hostname.endsWith('lan') && !this.hostname.endsWith('loc') && !this.hostname.endsWith('arenaturist.nivas.hr')) {
            $(this).attr({
                target: "_blank"
                //title: this.href + " (vanjski link, kliknite za otvoriti u novom prozoru)"
            });
        }
    });

};

var scrollToMap = function(selector) {

    var anchor = window.location.hash;
    var section = $(selector).length > 0 ? selector : null;

    if ( anchor === section )
    {
        var scrollTarget = $(selector).offset().top - $('#siteHead').height();
        //console.log(scrollTarget);
        $('html, body').animate({scrollTop: scrollTarget });
    }

};

var contentTableWrapper = function (selector) {
    $(selector).each(function() {
        $(this).wrap('<div class="table-wrapper"></div>');
        $(this).parent('.table-wrapper').after('<div class="swm">Swipe me</div>')
    });
};

var homeDateRangePickerPozition = function() {

    if ( $('body').hasClass('homePage') )
    {
        $('.DateRangePicker .DateInput__input').on('focus', function() {
            var poz = $(this).offset().top;
            var cal = 444;
            var scl = $(window).scrollTop();
            var wh  = $(window).height();

            var scrTo = poz - ( wh - cal );

            $('html, body').animate({scrollTop: scrTo });

        });
    }

};

var tabsAccordion = function() {

    var $accordionTabs = $('.accordion-tabs');

    $accordionTabs.accordionTabs({
        // Plugin options
        mediaQuery: '(min-width: 768px)' // Set when tabs should be used instead of accordion
    }, {
        // jQuery UI Accordion options <http://api.jqueryui.com/accordion/>
        header: 'h3', // Specify the heading level you used (required)
        heightStyle: 'content',
        active: true,
        collapsible: true
    }, {
        // jQuery UI Tabs options <http://api.jqueryui.com/tabs/>
        collapsible: true,
        active: false,
        show: {
            effect: 'fade'
        }
    });

};

var sidebarPhobsTabsAccordion = function() {
    var $accordion = $('.js-phobs-sidebar__accordion');

    $accordion.accordion({
        // jQuery UI Accordion options <http://api.jqueryui.com/accordion/>
        header: '.phobs-sidebar__room', // Specify the heading level you used (required)
        heightStyle: 'content',
        active: 0,
        collapsible: true
    });
};


var PhobsPrintableVersion = function() {
	var $printbtn  = $('.js-printable-version');
	$printbtn.click(function () {
		event.preventDefault();
		console.log('aaaprint');
		window.print();
	});
}

// $.fn.colorColecting = function (selector) {

//     return $(this).each(function() {

//         var elem = this;
//             hostname = window.location.hostname;

//         var invertColor = function(hexTripletColor) {
//             var color = hexTripletColor;
//             color = color.substring(1);           // remove #
//             color = parseInt(color, 16);          // convert to integer
//             color = 0xFFFFFF ^ color;             // invert three bytes
//             color = color.toString(16);           // convert to hex
//             color = ("000000" + color).slice(-6); // pad with leading zeros
//             color = "#" + color;                  // prepend #
//             return color;
//         };

//         var componentToHex = function(c) {
//             var hex = c.toString(16);
//             return hex.length == 1 ? "0" + hex : hex;
//         };

//         var rgbToHex = function(r, g, b) {
//             return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
//         };

//         var setup = function () {

//             var colorThief = new ColorThief(),
//                 color = colorThief.getColor(elem),
//                 normal = color.toString(),
//                 hexColor = rgbToHex(color[0],color[1],color[2]),
//                 invert = invertColor(hexColor),
//                 rgbToSingleNumber = color[0]+color[1]+color[2],
//                 halfColorNumber = 382.5,
//                 textColor = rgbToSingleNumber > halfColorNumber ? "0,0,0" : "255,255,255";
//             //console.log(color);

//             $('#pageHead .breadcrumb').css({
//                 'color':'rgb('+textColor+')',
//                 'background-color':'rgba('+color[0]+','+color[1]+','+color[2]+',.5)'
//             });
//             $('#pageHead .breadcrumb a').css('color','rgb('+textColor+')');

//         };

//         if ( hostname.endsWith("com") )
//         {
//             $(elem).one("load", function() {
//                 // do stuff
//                 setup();
//             }).each(function() {
//                 if(this.complete)
//                 {
//                     $(this).load();
//                 }
//             });
//         }
//         else if ( hostname === "arenaturist.marko.lan" )
//         {
//             //console.log('111');
//             //setup();
//         }
//         else
//         {
//             return;
//         }


//     });

// };

// Console Massage :slightly_smiling_face:
function sayHello() {
    if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
        var args = [
            '\n %c Made with :hearts: by NIVAS %c %c %c http://www.nivas.hr/ %c %c \n  Well, hello there, you sneaky snooper. \n  Like our site? Think you can do better?  \n  Let\'s talk. \n  http://www.nivas.hr/careers',
            'color: #fff; background: #0fc5d0 ; padding:5px 0;',
            'background: #494949 ; padding:5px 0;',
            'background: #494949 ; padding:5px 0;',
            'color: #fff; background: #1c1c1c ; padding:5px 0;',
            'background: #fff; padding:5px 0;',
            'color: #b0976d ; background: #fff; padding:5px 0; line-height:24px;'
        ];
    window.console.log.apply(console, args);
    } else if (window.console) {
        window.console.log('Made with love :hearts: NIVAS - http://www.nivas.hr/');
    }

}
//sayHello();

var razno = function () {
   $('.head-button--360').not('.no-js').on('click', function (e) {
        e.preventDefault();
    });
}


var viewAllAwards = function() {
    if ( $('.awwards-wrap').length ) {
        var elem = $('.awwards-wrap');
        if (elem.find('.awards.rest').length > 0) {
            elem.find('.awwards-inner-wrap').removeClass('noMore');
        }
        elem.find('.viewAll').on('click' , function(e) {
            e.preventDefault();
            elem.find('.awards.rest').toggleClass('showRest');
            elem.find('.awwards-inner-wrap').toggleClass('showLess');
        });
    }
};


var ArenaturistTabs = {

    init: function() {

        // sakrij sve osim .current pane
        $(".nvsTabs .js-tab-pane").not(".current").hide();


        this.bindEvents()
    },


    bindEvents: function() {

        // click event for upper tabs
        $(".nvsTabs .js-tab").on('click', function(e){
            e.preventDefault(); // prevent link event

            // definition of tab ID and friendly name
            tabId = $(this).data("id");
            tabFriendlyName = $(this).attr("data-tab");

            // class "current" on tab elements
            $(".nvsTabs .js-tab").removeClass("current");
            $(this).addClass("current");

            // hide all tabs, but show one that we have clicked
            $(".nvsTabs .js-tab-pane").hide();
            $(".nvsTabs .js-tab-pane-" + tabId).show();

            // when we change between tabs we need to close all open questions in accordion
            $('.nvsTabs').accordion({
                active: false,
            });

            // lets push GET param "tab" into our current URL and delete qa param (if exists)
            parseUrl.setQueryParam('tab', tabFriendlyName);
            parseUrl.delQueryParam('qa');
        });

        // click event for questions
        $(".nvsTabs .tab-label").on("click", function() {

            var tabFriendlyName = $("ul.inContentMeni a[class*='current']").data("tab");
            var qaId = $(this).data("qa-id"); // get ID of question
            var qaFriendlyName = $(this).data("qa-name"); // get friendly name of question

            if($(this).attr("aria-selected") == "true") { // if question is open,

                //then we wil remove GET params from URL
                parseUrl.delQueryParam('qa');

            } else { // if question is closed

                //then we wil add GET param into URL
                parseUrl.setQueryParam('tab', tabFriendlyName);
                parseUrl.setQueryParam('qa', qaFriendlyName);
            }
        });
    },
};

var ArenaRequestTesting = {

    init: function() {


        console.log("101010101010101010101010101010101010");
    
        $("#accommodation").on("change", function () {

            // on change first hide all LI elements of "ul.gdpr-list" and delete text area value
            $("ul.gdpr-list li").hide();
            $("#acc_sentance").text(liElement);

            // get label of optgroup of selected select menu
            var label=$('#accommodation :selected').parent("optgroup").index();

            // and then show the one that we need to show
            $("ul.gdpr-list li").eq(label - 1).show("slow");

            // and then fill the hidden textarea with value of that LI element
            var liElement = $("ul.gdpr-list li").eq(label - 1).text();
            $("#acc_sentance").text(liElement);
        });
    },
};


/**
 * object holds methods to deal with GET params in current URL
 */
var parseUrl = {

    /**
     * catches all GET parameters from current URL
     * @param {string} str - The string containing two comma-separated numbers.
     * @return {object} object holds all GET parameters from URL
     */
    getAllQueryParams: function(){

        var returnValue = new Object(); // object that we will return
        var query = new URL(window.location); // get part of our current URL

        if(query.search) // if query exists
        {
            // get array of params
            var strings = query.search.split("?")[1];
            strings = strings.split("&");

            // rotate array of query params
            for(var i= 0; i <= strings.length - 1; i++) {

                var paramName = strings[i].split("=")[0];
                var paramValue = strings[i].split("=")[1];

                // check values before inserting them into object
                if((paramName && paramValue) &&
                    paramName.match(/[a-zA-Z1-9]+/g) &&
                    paramValue.match(/[a-zA-Z1-9]+/g))
                {
                    returnValue[paramName] = paramValue;
                }
            }
        }
        return returnValue;
    },

    /**
     * sets defined variable name and its value to current URL as GET parameters
     * @param {string} $name - name of GET param
     * @param {string} $value - value of GET param
     * @return {void}
     */
    setQueryParam: function($name, $value){

        this.delQueryParam($name); // if defined tab already exists, then first delete it
        var allGetParams = this.getAllQueryParams(); // catch all GET params if they exist
        var queryString = this.convertToUrlString(allGetParams); // convert string for URL

        queryString += (Object.keys(allGetParams).length > 0) ? '&' : ''; // make "&"" character
        queryString += $name + "=" + $value; // add defined values to string

        history.pushState({}, "", queryString); // push all params to URL
    },

    /**
     * deletes defined property in object of GET parametersers
     * @param {string} $name - name of object parameter that we want to delete
     * @return {void}
     */
    delQueryParam: function($name) {

        var allGetParams = this.getAllQueryParams(); // catch all GET params if they exist
        if(allGetParams.hasOwnProperty($name)) { // if we have that property

            delete allGetParams[$name]; // lets delete that property

            var queryString = this.convertToUrlString(allGetParams); // convert string for URL
            history.pushState({}, "", queryString); // push all params to URL
        }

        // after we have deleted GET param, maybe a character "?" is left in URL. Now we will check for it and if it exists we will delete it also

        var query = new URL(window.location); // get part of our current URL
        var numParams = Object.keys(allGetParams).length;

        if(numParams == 0 && query.href.slice(-1) == "?") {

            history.pushState({}, "", query.href.slice(0, -1)); // push corrected URL, without character "?"
        }
    },

    /**
     * converts given object into string to push into our current URL
     * @param {object} $object - name of GET param
     * @return {string} - return string
     */
    convertToUrlString: function($object) {

        var numParams = Object.keys($object).length; // number of properties in defined object
        var returnValue = '?'; // there is where we will save our string

        if(typeof $object === 'object' && numParams > 0) { // if there is at least one GET param
            for(var paramName in $object) {
                var paramValue = $object[paramName];
                returnValue += paramName + "=" + paramValue + "&";
            }

            returnValue = returnValue.slice(0, -1); // remove last "&" character from string"
        }

        return returnValue;
    },
};


var faqTabsAccordion = function() {

    // $accordion is defined as .nvsTabs is a container, so when we open one question in one tab, then all others are closed. For different scopes, we can change into ".tabs" or ".container"
    var $accordion = $('.nvsTabs');
    var expandLink = $('.faq-load-more');
    var closeLink = $('.faq-close-all');

    $accordion.accordion({
        // jQuery UI Accordion options <http://api.jqueryui.com/accordion/>
        header: '.tab-label', // Specify the heading level you used (required)
        heightStyle: 'content',
        active: false,
        animate: 600,
        collapsible: true
    });

    expandLink.click(function(){
        $(this).closest(".tabs").toggleClass("open-all")
        $(this).closest(".tabs").find(".tab-content").css("display","block");
        // $(".ui-accordion-content").show();
    });
    closeLink.click(function(){
        $(this).closest(".tabs").removeClass("open-all")
        $(this).closest(".tabs").find(".tab-content").css("display","none");
        $(this).closest(".tabs").find(".tab-label").removeClass("ui-accordion-header-active", "ui-state-active");
        $(this).closest(".tabs").find(".tab-label").attr( "aria-selected", "false");
        $(this).closest(".tabs").find(".tab-label").attr( "aria-expanded", "false");
        // $(".ui-accordion-content").show();
    });
};

var simpleDatepicker = {

    init: function() {

        // datepicker for element #birthday
    	if ($('#birthday').length) {
            var elem = document.querySelector('input[name="birthday"]');
			var datepicker = new Datepicker(elem, {
                // options here
                autohide: true, // hide it after selecting date
                startView: 2,
                format: 'dd/mm/yyyy',
                defaultViewDate: "01/01/1970"
			});
        }

        // datepicker for element #testing_date
        if ($('#testing_date').length) {
        	var date = new Date();
            date.setDate(date.getDate()+14); // limit prijave na 2 tjedna od trenutačnog datuma

        	var elem = document.querySelector('input[name="testing_date"]');
			var datepicker = new Datepicker(elem, {
                // options here
                autohide: true, // hide it after selecting date
                format: 'dd/mm/yyyy',
                // maxDate: date
                maxDate: '15-10-2021'
			});
       }
    },
};



function sidebarTabs() {


	if($('.js-tabs').length ) {

		$('.js-tabs li').click(function () {
			var tab_id = $(this).attr('data-tab');

			$('.js-tabs li').removeClass('is-current');
			$('.js-tab-content').removeClass('is-current');

			$(this).addClass('is-current');
			$("#" + tab_id).addClass('is-current');
		});
	}

}


/* 6.Phobs JS */

// phobs - Property amenities popup toggle
function amenitiesPopupToggle() {
	$(".js-close-amenities-popup").click(function (e) {
		e.preventDefault();
		$(this).parent(".sidebar-unit-amenities__popup").removeClass("is-active");

	});

	$(".js-toggle-amenities-popup").click(function (e) {
		e.preventDefault();

		if ($(this).closest(".sidebar-unit-amenities").find(".sidebar-unit-amenities__popup").hasClass("is-active")) {
			$(this).closest(".sidebar-unit-amenities").find(".sidebar-unit-amenities__popup").removeClass("is-active");
		} else {
			$(this).closest(".sidebar-unit-amenities").find(".sidebar-unit-amenities__popup").addClass("is-active");
		}

	});
}












$(document).ready(function () {


	amenitiesPopupToggle();

	sidebarTabs();

    // objectFitVideos();
    VuduGdprPlugin.init();
    ArenaturistPhotoSwipe.init();
	ArenaturistSocial.init();
    ArenaturistNewsletter.init();
    ArenaturistGoogleMaps.init();
    ArenaturistTabs.init();

    ArenaturistRequest.init(); 
    // ArenaRequestTesting.init(); // @mark sta je ovo???

	gtm_Tracking.init();
	ArenaturistTrackYoutube.init();

//\\Razno\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//
	PhobsConfirmationSidebarExpand();
    sidebarPhobsTabsAccordion();
    razno();
    PhobsPrintableVersion();
    faqTabsAccordion();

	GuaranteeSwiper();
	scrollToContentMenu();
    viewAllAwards();

	$('.nvsSel').nivasSelect();

    simpleDatepicker.init();

//\\ColorColecting\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//
    if ( $('.breadcrumb').length )
    {
        // $('.accomodationPage #pageHead .pic .gf').colorColecting();
        // $('.destinationPage #pageHead .pic .gf').colorColecting();
        // $('.specialOffersPage #pageHead .pic .gf').colorColecting();
        // $('.aboutPage #pageHead .pic .gf').colorColecting();
        // $('.newsEventsPage  #pageHead .pic .gf').colorColecting();
    }

//\\Homepage above the fold\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//
    homePageHead.init();

//\\Expandable box\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//
    $('.expandableList').expandableList();

//\\Box six accordion/\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//
     $('.boxStyle6').boxStyle6Action();

//\\Equal Height//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\
    setTimeout(function(){
        equalheightWraper();
    }, 800);

//\\Drop down plugin//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\
    //$('.filter > li').dropDownOnHover();
    $('.filter').dropDownOnClick();

//\\Device by width detection/\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\
    deviceByWidthDetection.init();

//\\Tabs accordion\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\
    //ammenitesTabsAccordion.init();
    ammenitesSlider.init();

//\\Accomodation serch\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\
    // searchAccoBar();

//\\Booking page//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\
    // bookAccoPage();

//\\Footer navigation/\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\
	footNavigation.init();

//\\Newsletter form validation\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\
	// $(".newsletterForm").validate({
    //        //submitHandler: function() { $(".newsletterForm input#email").val(""); }
    //    });
    // $("#commentForm").validate();
	// 	// rules: {
	// 	//     email: {
	// 	//       required: true,
	// 	//       email: true
	// 	//     }
	// 	// }
	// 	//submitHandler: function(form) {
	// 	//    $(form).ajaxSubmit();
	// 	//}
	// 	// messages: {
	// 	//   email: {
	// 	//     required: "11We need your email address to contact you",
	// 	//     email: "22Your email address must be in the format of name@domain.com"
	// 	//   }
	// 	// }
	// });

//\\Accomodation serch\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\
    // $('.wrapVideo').fitVids();
    // $('.newsSingleContent').fitVids();

//\\Download documents icons//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\
    downloadDocs();

//\\Hover class\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\
    // hoverica();
    // badu 03.04. smeta na booking funnelu

//\\External links\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\
    extLinks();

//\\Responcive table wrapper//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\
    contentTableWrapper('.aboutSingleContent table');
    contentTableWrapper('.boxStyle6 .wrap table');


//\\Scroll to map/\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\
    scrollToMap('#gmapAnchor');


//\\Home date range oicker pozition\//\\//\\//\\//\\//\\//\\//\\//\\//\\
    homeDateRangePickerPozition();

//\\Tabs Accordion\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\
    tabsAccordion();

	findAvailableUnits();
	PhobsShowResultsFromTabs();
});


//\\On resize/\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//
$(window).resize(function(){
    equalheightWraper();
});

//\\On load\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//
//$(window).load(function() {

//\\Move booking mask home/\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//
	//bookingMaskMove();

//});

//\\On scroll/\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//
/*$(window).scroll(function(){


});*/


// Loader
// jQuery(document).ready(function($) {

// 	ArenaLoader.init({

// 		onInit: function(){

// 		},

// 		onFirstTime: function(){


// 		},

// 		onBlock: function() {

// 		},

// 		onFinish: function() {

// 		}


// 	}).run();

// });

$.fn.serializeObject = function () { "use strict"; var a = {}, b = function (b, c) { var d = a[c.name]; "undefined" != typeof d && d !== null ? $.isArray(d) ? d.push(c.value) : a[c.name] = [d, c.value] : a[c.name] = c.value }; return $.each(this.serializeArray(), b), a };

var findAvailableUnits = function () {
    var $button = $('.x_searchNowBtn');

    $button.on('click', function (e) {
        e.preventDefault();

        $form = $('#searchForm');
        formdata = $form.serializeObject();
        console.log(formdata);

        jQuery.ajax({
            url: '/' + langCode + '/xphobs/units',
            type: 'POST',
            dataType: 'json',
            data: formdata,
            success: function (resData, textStatus, xhr) {
                // cb(resData, textStatus, xhr);
            },
            complete: function (xhr, textStatus) { },
            error: function (xhr, textStatus, errorThrown) { }
        });
    });
};


//Phobs sidebar na confirmation screenu(non-vue)
var PhobsConfirmationSidebarExpand = function() {

	$( ".js-phobs-sidebar-btn" ).click(function() {
		$( ".phobs-sidebar__content" ).toggle();
		$( ".js-phobs-header" ).toggle();
	  });

}
//Swiper slider za guarantee blok/listu na mobileu
var GuaranteeSwiper = function() {
	var guaranteeContainer = $(".swiper-guarantee");
	var guaranteeList = $(".guarantee-list");
	var guaranteeItem = $(".guarantee-list__item");

	if (isMobile.any() && guaranteeContainer.length > 0) {
		guaranteeList.addClass( "swiper-wrapper");
		guaranteeItem.addClass( "swiper-slide");

		var guaranteeSwiper = new Swiper('.swiper-guarantee', {
			autoplay: 3000,
			loop: true,
		});
	}
	else {
		return;
	}
}

//funkcija da se prozor zascrolla do tabova na stranici sa smjestajem
var scrollToContentMenu = function() {
	var accommodationAltPage = $(".accomodationSingleIntroAlt ");
	var contentMenu = $("#inContentMenu");
    var scrollableContainer = $('.scrollableContainer');
	var bookingMask = $("#searchAccomodation");

	// if(accommodationAltPage.length > 0 && contentMenu.length > 0) {
	// 	$("body,html").animate(
	// 		{
	// 		  scrollTop: bookingMask.offset().top
	// 		},
	// 		0 //speed
	// 	);
	// }
	// else {
	// 	return;
	// }
    if(contentMenu.length > 0) {
		var whereTo = contentMenu.find('.current').position().left;
		scrollableContainer.scrollLeft(whereTo);
    }
}

//phobs rezultati kada se okine show results s neke stranice koja nije phobs/units
var PhobsShowResultsFromTabs = function() {
	var accommodationPage = $(".accomodationPage");

	if (accommodationPage.length) {
		var url = window.location.href;
		var urlSegment = url.lastIndexOf('#');

		if (urlSegment !== -1 && url.substring(urlSegment) == '#results' ) {
			$("body,html").animate(
				{
					scrollTop: $(".swiper-guarantee--second").offset().top
				},
				0
			);
		}
	}
	else {
		return;
	}
}








// from main-foot.js


//price guarantee promo code
if ($('.js-promo').length > 0) {
	$(".js-promo").click(function() {
		$(this).addClass("hide");
		$(".promo-code-wrapper").addClass("show");
	});

	$(".close-promo-code").click(function() {
		$(".promo-code-wrapper").removeClass("show");
		$(".js-promo").removeClass("hide");
	});

}

//price guarantee promo code switch cancel/OK buttona
if ($('.promo-code input').length > 0) {
	$('.promo-code input').on("input", function()
	{
		if( !$(this).val() ) {
			$(".promo-code").removeClass("code-entered");
		}
		else {
			$(".promo-code").addClass("code-entered");
		}
	});
}


//price guarantee closing single tabs
if ($('#mainTab').length > 0) {
	$('#mainTab a .close-tab').click(function (e) {
		var tab = $(this);
		if(tab.closest('li').hasClass('active')){
			window.setTimeout(function(){
				$(".tab-pane").removeClass('active');
				tab.closest('li').removeClass('active');
			},1);
		}
	});
}

// if( $('#mainTab').length > 0 && Modernizr.mq('(max-width: 899px)') ) {
	// $('#mainTab').tabCollapse({
	// 	accordionClass: 'visible-xs main-accordion'
	// });
// 	//console.log('tabCollapse');
// }
// if( $('#mainTab').length > 0 ) {
// 	$('#mainTab').tabCollapse();
// }
// 	$('#myTab').tabCollapse();

//booking form after element on focus
if ($('#arrivalDate').length > 0) {
	function focusArriDate(isOnFocus)
	{
		if (isOnFocus)
			$(".wrapArriDate").addClass("focused");
		else
			$(".wrapArriDate").removeClass("focused");
	}
}

if ($('#departureDate').length > 0) {
	function focusDeppDate(isOnFocus)
	{
		if (isOnFocus)
			$(".wrapDeppDate").addClass("focused");
		else
			$(".wrapDeppDate").removeClass("focused");
	}
}


var scrollToBooking = function () {
	if($("body.scrollToBooking").length > 0 || window.location.search != '')
    {
		var hash = $("#searchAccomodation");
        if(hash.length>0)
        {
            var offset =  !isMobile.any() ? 0 : 60;
            var scrollToPlace = hash.offset().top - offset;

            $('html,body').animate({
                scrollTop: scrollToPlace
            },{
                duration: 0,
                complete: function() {
                    if ( !isMobile.any() ) {
                        $('#siteHead').addClass("menu_slide_up");
                        $('#siteHead').removeClass("menu_slide_down");
                    }
                }
            });
        }


    }
}


//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\
//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\//\\

//\\//\\//\\requestAnimationFrame polyfill\\//\\//\\//\\//\\//\\//\\//\\

// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
// requestAnimationFrame polyfill by Erik MÃ¶ller. fixes from Paul Irish and Tino Zijdel
// MIT license

(function() {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
                                   || window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() { callback(currTime + timeToCall); },
              timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };

    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
}());

//\\//\\//\\//\\mobile tablet detection\\//\\//\\//\\//\\//\\//\\//\\//\\
var isMobile = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    iPad: function() {
        return navigator.userAgent.match(/iPad/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.iPad() || isMobile.Opera() || isMobile.Windows());
    }
};


var meniMod = (function ($, window, document, undefined) {

    var _paths = {
        //element: '#siteHead',
        _element: $('#siteHead'),
        _body: $('body'),

        //desktop vars
        _deskNavWrap: $('#siteHead nav'),
        _deskNav: $('#siteHead .mainNav'),
        _deskNavAx: $('#siteHead .apendix_nav'),
        _deskDrop: $('#siteHead .mainNav li.drop'),
        _langDrop: $('#siteHead .mainNav li.lang'),

        //mobile vars
        _mobNavWrap: $('#siteHead nav'),
        _mobNav: $('#siteHead .mainNav'),
        _mobDrop: $('#siteHead .mainNav li.drop'),
        _mobDropMore: $('#siteHead .mainNav li.drop > .more')
    };

    var _utils = {
        //utilities
        _resizeTimeout: null,
        _model: [],
        _top: $(window).scrollTop(),
        _direction: null,
        _mobileInitialized: false,
        _desktopInitialized: false
    };

    var init = function () {
        // console.log(_paths);
        // console.log(_utils);
        _initSelector();

        // Resze lisiner
        window.addEventListener("resize", function () {
            if(_utils._resizeTimeout){
                clearTimeout(_utils._resizeTimeout);
            }
            _utils._resizeTimeout = setTimeout(function(){

                _initSelector();

                setTimeout(function() {
                    _cleaner();
                    if ( Modernizr.mq('(min-width: 900px)') ) {
                        _dropSpof();
                    }
                });

            }, 200);
        });

        addOneScroll();

    };

    var _initSelector = function(){

        //if ( isMobile.any() && _utils._mobileInitialized === false )
        if ( window.isHandheld && _utils._mobileInitialized === false )
        {
            _initMobile();
            // console.log('init mobile');
        }

        // if ( !isMobile.any() && _utils._desktopInitialized === false )
        if ( window.isDextop && _utils._desktopInitialized === false )
        {
            _initDesktop();
            // console.log('init dextop');
        }

        //_tabs();
    };

    var _initMobile = function () {

        _populateModelAllClosed();
        _goUpDonwMobile();
        _mobOpenMeni();

        if ( isMobile.iPad() )
        {
            _dropSpof();
        }
        //_mobOpenSrch();
        //_randomStuff();

        _utils._mobileInitialized = true;
    };

    var _initDesktop = function () {
        //Hover event;
        var config = {
            sensitivity: 1, // number = sensitivity threshold (must be 1 or higher)
            interval: 10, // number = milliseconds for onMouseOver polling interval 200
            over: _goDownDesktop, // function = onMouseOver callback (REQUIRED)
            timeout: 100, // number = milliseconds delay before onMouseOut 300
            out: _goUpDesktop // function = onMouseOut callback (REQUIRED)
        };


        if ( !isMobile.any() ) {
            var test = _paths._deskDrop.hoverIntent( config );
        }

        _flopy_navigation();
        _dropSpof();
        //_openCloseSearch();
        //_randomStuff();

        _utils._desktopInitialized = true;
    };

    var _cleaner = function () {

        if ( _paths._element.hasClass('toggle_menu') ) {
            _paths._element.removeClass('toggle_menu')
            _scrollBlock();
        }
        $("#rwd_menu").removeClass('toggle_menu_opened');
        _paths._mobNavWrap.removeAttr('style');
        _paths._mobNav.removeAttr('style');
        _paths._mobDrop.removeAttr('style');
        _paths._mobDrop.find('.sub').removeAttr('style');
        _paths._langDrop.find('.sub').removeAttr('style');
        _paths._deskNavWrap.removeAttr('style');
        _paths._deskDrop.find('.spof .col').removeAttr('style');

        _paths._deskDrop.removeClass('droped').removeClass('hover');

        _populateModelAllClosed();

    };

    var _tabs = function () {
        var acco = $( "#siteHead nav .hoap .sub" );
        if ( Modernizr.mq('(min-width: 768px)') ) {
            if ( acco.accordion( "instance" ) != undefined ) {
                acco.accordion('destroy');
            }
        }
        else {
            acco.accordion({
                heightStyle: "content"
            });
        }
    };

    var _populateModelAllClosed = function() {

        // punim arr sa statusima menija + dodavanje handlera data-id
        _paths._mobDrop.each(function (i) {
            //i = i+1;
            $(this).attr('data-id',i);
            _utils._model[i] = 'closed';
        });

    };

    var _flopy_navigation = function () {
        $(window).scroll(function(){
            var _cur_top = $(window).scrollTop();
            if ( _utils._top < _cur_top )
            {
                _utils._direction = 'down';
                if ( $(window).scrollTop() + $(window).height() == $(document).height() )
                {
                    _paths._element.addClass("menu_slide_down");
                    _paths._element.removeClass("menu_slide_up");
                }
                else if ( _cur_top >= 106 )
                {
                    _paths._element.addClass("menu_slide_up");
                    _paths._element.removeClass("menu_slide_down");
                    _paths._element.addClass('scrolled');
                }
            }
            else
            {
                _utils._direction = 'up';
                _paths._element.removeClass("menu_slide_up");
                _paths._element.addClass("menu_slide_down");
                if ( _cur_top <= 80 )
                {
                    _paths._element.removeClass('scrolled');
                }
            }

            _utils._top = _cur_top;
        });
    };

    var _allClosed = function (element, index, array) {
        return element === 'closed';
    };

    var _goDownDesktop = function (el) {
        var self = !isMobile.any() ? this : el;
        $(self).addClass("hover");
    };

    var _goUpDesktop = function (el) {
        var self = !isMobile.any() ? this : el;
        $(self).removeClass("hover");
    };

    var _goDownMobile = function (el) {
        var elem = el;

        $(elem).prev('.sub').slideDown();
        $(elem).parent('.drop').addClass('droped').addClass('hover');
    };

    var _goUpMobile = function (el) {
        var elem = el;

        $(elem).prev('.sub').slideUp();
        $(elem).parent('.drop').removeClass('droped').removeClass('hover');
    };

    var _goToTop = function () {
        $('html, body').animate({scrollTop:0});
    };

    var _callBack = function () {
        //console.log('this is RQAF callback', this);
    };

    var _goUpDonwMobile = function () {
        _paths._mobDrop.append('<span class="more"></span>');

        _paths._mobDrop.find('.more').bind('click', function (event) {//touchstart

            var par = $(this).parent('.drop');
            var tId = par.attr('data-id');
            var _this = $(this);

            if( _utils._model[tId] == 'closed' )
            {
                var others = $(this).parent('.drop').siblings('.hover');

                //otvori
                if ( $(window).width() < 900 )
                {
                    requestAnimationFrame(_callBack, _goDownMobile(this));
                }
                else
                {
                    _goDownDesktop(par);
                }
                _utils._model[tId] = 'opened';

                //kada otvaram submenu zatvaram siblings
                others.not(this).each(function () {
                    var tIdO = $(this).attr('data-id'),
                        more = $(this).children('.more');

                    if ( $(window).width() < 900 )
                    {
                        requestAnimationFrame(_callBack, _goUpMobile(more));
                    }
                    else {
                        _goUpDesktop($(this));
                    }
                    _utils._model[tIdO] = 'closed';
                });
            }
            else if( _utils._model[tId] == 'opened' )
            {
                //zatvori
                if ( $(window).width() < 900 )
                {
                    requestAnimationFrame(_callBack, _goUpMobile(this));
                }
                else
                {
                    _goUpDesktop(par);
                }
                _utils._model[tId] = 'closed';
            }

        });
    };

    var _scrollBlock = function () {
        // lock scroll position, but retain settings for later
        var scrollPosition = [
            window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
            window.pageYOffset || document.documentElement.scrollTop  || document.body.scrollTop
        ];

        if ( _paths._element.hasClass('toggle_menu') )
        {
            var html = $('html'); // it would make more sense to apply this to body, but IE7 won't have that
            html.data('scroll-position', scrollPosition);
            html.data('previous-overflow', html.css('overflow'));
            html.css('overflow', 'hidden');
            window.scrollTo(scrollPosition[0], scrollPosition[1]);
        } else {
            // un-lock scroll position
            var html = $('html');
            var scrollPosition = html.data('scroll-position');
            html.css('overflow', html.data('previous-overflow'));
            window.scrollTo(scrollPosition[0], scrollPosition[1]);
        }
    };

    var _mobOpenMeni = function () {
        $("#rwd_menu").on("click", function(e) {
            e.preventDefault();

            var allOpenChildren = _paths._element.find('.droped');

            _paths._mobNavWrap.css('height', (window.innerHeight-60) );

            // if ( _paths._element.hasClass('toggle_srch') )
            // {
            //     $('#rwd_srch').trigger('click');
            // }

            $(this).toggleClass("toggle_menu_opened");
            _paths._element.toggleClass("toggle_menu");

            //kada zatvaram ili otvaram meni zatvori sve podmenije
            allOpenChildren.each(function () {
                var tIdO = $(this).attr('data-id'),
                    more = $(this).children('.more');
                requestAnimationFrame(_callBack, _goUpMobile(more));
                _utils._model[tIdO] = 'closed';
            });

            _scrollBlock();

            window.navigator.vibrate(80);

        });
    };

    // var _mobOpenSrch = function () {
    //     $("#rwd_srch").on("click", function(e) {
    //         e.preventDefault();

    //         if ( _paths._element.hasClass('toggle_menu') )
    //         {
    //             $('#rwd_menu').trigger('click');
    //         }
    //         $(this).toggleClass("toggle_srch_opened");
    //         _paths._element.toggleClass("toggle_srch");
    //     });
    // };

    // var _openCloseSearch = function () {
    //     var searchBox = _paths._deskNavWrap.find('.search-box'),
    //         searchInput = _paths._deskNavWrap.find('#search-input'),
    //         searchInputW = searchInput.width();

    //     _paths._deskNavAx.find('a.op').on("click", function(e) {
    //         e.preventDefault();
    //         _paths._langDrop.addClass('move');
    //         searchBox.addClass('open');

    //         searchInput.focus();
    //     });
    //     _paths._deskNavAx.find('a.cl').on("click", function(e) {
    //         e.preventDefault();
    //         _paths._langDrop.removeClass('move');
    //         searchBox.removeClass('open');
    //     });

    //     // Save current value of element
    //     searchInput.data('oldVal', searchInput.val());

    //     // Look for changes in the value
    //     searchInput.on("propertychange change click keyup input paste", function(event){
    //         // If value has changed...
    //         if (searchInput.data('oldVal') != searchInput.val()) {
    //             // Updated stored value
    //             searchInput.data('oldVal', searchInput.val());

    //             // Do action
    //             $('body').append('<span id="phantom_search_input_width"></span>');
    //             var val = $(this).val();
    //             $('#phantom_search_input_width').text($(this).val());
    //             if (val == '' || val == $(this).attr('placeholder')) {
    //                 searchInput.width(searchInputW);
    //             } else {
    //                 if ( $('#phantom_search_input_width').width() < 1402 && $('#phantom_search_input_width').width() > 120 ) {
    //                     searchInput.width($('#phantom_search_input_width').width() + 10);
    //                 }
    //             }
    //             $('#phantom_search_input_width').remove();
    //         }
    //     });
    // };

    // var _bindEvents = function () {

    // };

    // var _randomStuff = function () {
    //     $('#siteHead nav .mainNav .drop.more > a').on('click', function (e) {
    //         e.preventDefault();
    //         if ( Modernizr.mq('(max-width: 767px)') ) {
    //             $('.drop.more > .more').trigger('click');
    //         }
    //     });
    //     $('#siteHead nav .apendix_nav .lang > a').on('click', function (e) {
    //         e.preventDefault();
    //     });
    // };

    var _dropSpof = function() {

        _paths._deskNav.find('.spof').find('.sub').removeAttr('style');

        if ( _paths._deskNav.find('.spof').length !== 0 )
        {
            var elem = _paths._deskNav.find('.spof');
            var elW = elem.find('.sub').outerWidth();
            var elP = elem.find('.sub').position().left;

            var elParW = elem.outerWidth();
            var elParP = elem.position().left;

            var calc1 = elParP + ( elParW / 2 );
            var calc2 = elP + ( elW / 2 );
            var calc3 = calc1 - calc2;

            elem.find('.sub').css({
                'left': calc3,
                'margin-left': '18px'
            });
        }
    };

    var addOneScroll = function() {

        var currentScroll = $(window).scrollTop();
        var newScroll = currentScroll === 0 ? 0 : ( currentScroll - 1 );
        $("html, body").animate({ scrollTop: newScroll });

    };

    var scrollToBooking = function () {
        if($("body.scrollToBooking").length > 0)
        {
            var hash = $("#searchAccomodation");
            var offset;
            if ( $('#siteHead').hasClass('menu_slide_down') ) {
                offset = 0;
                console.log('aaaa');
            } else {
                offset = $('#siteHead').height();
                console.log('bbb');
            }
            $('html,body').animate({
                scrollTop: hash.offset().top - offset
            },{
                duration: 500,
                complete: function() {
                }
            });
        }
    }


    return {
        init: init
    };

})(jQuery, window, document);



if (window.addEventListener) {
    window.addEventListener('DOMContentLoaded', meniMod.init(), false);
}



$(document).ready(function () {

	// scrollToBooking();
});
